"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NRail User Management Service API
 * NRail User Management Service API
 *
 * The version of the OpenAPI document: 1.21.1
 * Contact: it@nrail.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApi = exports.ServiceApiFactory = exports.ServiceApiFp = exports.ServiceApiAxiosParamCreator = exports.RolesApi = exports.RolesApiFactory = exports.RolesApiFp = exports.RolesApiAxiosParamCreator = exports.RightsObjectsApi = exports.RightsObjectsApiFactory = exports.RightsObjectsApiFp = exports.RightsObjectsApiAxiosParamCreator = exports.ResourceGroupsApi = exports.ResourceGroupsApiFactory = exports.ResourceGroupsApiFp = exports.ResourceGroupsApiAxiosParamCreator = exports.OrganisationsParentsApi = exports.OrganisationsParentsApiFactory = exports.OrganisationsParentsApiFp = exports.OrganisationsParentsApiAxiosParamCreator = exports.OrganisationsMergerApi = exports.OrganisationsMergerApiFactory = exports.OrganisationsMergerApiFp = exports.OrganisationsMergerApiAxiosParamCreator = exports.OrganisationsChildrenApi = exports.OrganisationsChildrenApiFactory = exports.OrganisationsChildrenApiFp = exports.OrganisationsChildrenApiAxiosParamCreator = exports.OrganisationsAccessRightsApi = exports.OrganisationsAccessRightsApiFactory = exports.OrganisationsAccessRightsApiFp = exports.OrganisationsAccessRightsApiAxiosParamCreator = exports.OrganisationsApi = exports.OrganisationsApiFactory = exports.OrganisationsApiFp = exports.OrganisationsApiAxiosParamCreator = exports.InvitationsApi = exports.InvitationsApiFactory = exports.InvitationsApiFp = exports.InvitationsApiAxiosParamCreator = exports.AuthPasskeyApi = exports.AuthPasskeyApiFactory = exports.AuthPasskeyApiFp = exports.AuthPasskeyApiAxiosParamCreator = exports.AuthOtpApi = exports.AuthOtpApiFactory = exports.AuthOtpApiFp = exports.AuthOtpApiAxiosParamCreator = exports.AuthCertificatesApi = exports.AuthCertificatesApiFactory = exports.AuthCertificatesApiFp = exports.AuthCertificatesApiAxiosParamCreator = exports.AuthBasicApi = exports.AuthBasicApiFactory = exports.AuthBasicApiFp = exports.AuthBasicApiAxiosParamCreator = exports.AuthAccountCertificatesApi = exports.AuthAccountCertificatesApiFactory = exports.AuthAccountCertificatesApiFp = exports.AuthAccountCertificatesApiAxiosParamCreator = exports.AuthAccountAccessRightsApi = exports.AuthAccountAccessRightsApiFactory = exports.AuthAccountAccessRightsApiFp = exports.AuthAccountAccessRightsApiAxiosParamCreator = exports.AccountsSettingsApi = exports.AccountsSettingsApiFactory = exports.AccountsSettingsApiFp = exports.AccountsSettingsApiAxiosParamCreator = exports.AccountsPersonsMembershipsApi = exports.AccountsPersonsMembershipsApiFactory = exports.AccountsPersonsMembershipsApiFp = exports.AccountsPersonsMembershipsApiAxiosParamCreator = exports.AccountsPersonsApi = exports.AccountsPersonsApiFactory = exports.AccountsPersonsApiFp = exports.AccountsPersonsApiAxiosParamCreator = exports.AccountsPasskeyApi = exports.AccountsPasskeyApiFactory = exports.AccountsPasskeyApiFp = exports.AccountsPasskeyApiAxiosParamCreator = exports.AccountsDevicesMembershipsApi = exports.AccountsDevicesMembershipsApiFactory = exports.AccountsDevicesMembershipsApiFp = exports.AccountsDevicesMembershipsApiAxiosParamCreator = exports.AccountsDevicesApi = exports.AccountsDevicesApiFactory = exports.AccountsDevicesApiFp = exports.AccountsDevicesApiAxiosParamCreator = exports.AccountsAccessRightsRevocationApi = exports.AccountsAccessRightsRevocationApiFactory = exports.AccountsAccessRightsRevocationApiFp = exports.AccountsAccessRightsRevocationApiAxiosParamCreator = exports.AccountsApi = exports.AccountsApiFactory = exports.AccountsApiFp = exports.AccountsApiAxiosParamCreator = exports.UpdateRoleAccessRights404ResponseResultCodesEnum = exports.UpdatePersonAccountAvatarImage415ResponseResultCodesEnum = exports.UpdatePersonAccountAvatarImage404ResponseResultCodesEnum = exports.UpdatePersonAccount409ResponseResultCodesEnum = exports.UpdateOrganisationOwnership404ResponseResultCodeEnum = exports.TokenRequestFailureResponseResultCodeEnum = exports.ServiceStatusProductionModeEnum = exports.ServiceStatusTokenRevocationServiceStatusEnum = exports.ServiceStatusCertificateManagerStatusEnum = exports.ServiceStatusDatabaseConnectionStatusEnum = exports.RoleTypeRead = exports.RoleTypeCreate = exports.ResourceType = exports.ResourceProxyType = exports.ResourceGroupEntryType = exports.PersonAccountAuthentificationMethod = exports.PasskeyResetRequestOriginEnum = exports.Locale = exports.InvitationRequestTypeEnum = exports.GetServiceStatus500ResponseResultCodeEnum = exports.GetServiceReadiness500ResponseStatusEnum = exports.GetServiceReadiness200ResponseStatusEnum = exports.GetServiceLiveness500ResponseStatusEnum = exports.GetPersonAccountRoleAssignmentsInOrganisation404ResponseResultCodeEnum = exports.GetPersonAccountAvatarImage409ResponseResultCodesEnum = exports.GetAccountResourcesInOrganisationUnsecured404ResponseResultCodesEnum = exports.DeviceAccountAuthentificationMethod = exports.DeletePersonAccountRoleAssignmentInOrganisation409ResponseResultCodeEnum = exports.DeleteChildOrganisationRelationship404ResponseResultCodeEnum = exports.CreateRefreshToken409ResponseResultCodeEnum = exports.CreateOrganisation409ResponseResultCodeEnum = exports.CreateOrganisation404ResponseResultCodeEnum = exports.CreateInvitation404ResponseResultCodeEnum = exports.CreateAccessToken401ResponseResultCodeEnum = exports.AddPersonAccountRoleAssignmentInOrganisation409ResponseResultCodeEnum = exports.AddPersonAccountRoleAssignmentInOrganisation404ResponseResultCodeEnum = exports.AccountType = exports.AcceptInvitation409ResponseResultCodeEnum = exports.AcceptInvitation404ResponseResultCodeEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.AcceptInvitation404ResponseResultCodeEnum = {
    RoleOrInvalidOwner: 'err_unknown_role_or_invalid_owner',
    Account: 'err_unknown_account'
};
exports.AcceptInvitation409ResponseResultCodeEnum = {
    DuplicateAccountName: 'err_duplicate_account_name',
    DuplicateOrganisationName: 'err_duplicate_organisation_name',
    NrailNotAllowedAsChild: 'err_nrail_not_allowed_as_child',
    CircularRelationshipNotAllowed: 'err_circular_relationship_not_allowed',
    OrganisationsIdentical: 'err_organisations_identical',
    CannotCopyTemplateRole: 'err_cannot_copy_template_role',
    CannotCreateRelationship: 'err_cannot_create_relationship'
};
/**
 * The type of an account
 * @export
 * @enum {string}
 */
exports.AccountType = {
    Person: 'person',
    Device: 'device'
};
exports.AddPersonAccountRoleAssignmentInOrganisation404ResponseResultCodeEnum = {
    Organisation: 'err_unknown_organisation',
    Relationship: 'err_unknown_relationship',
    Role: 'err_unknown_role',
    Account: 'err_unknown_account'
};
exports.AddPersonAccountRoleAssignmentInOrganisation409ResponseResultCodeEnum = {
    DuplicateAssignment: 'err_duplicate_assignment',
    OwnerAccount: 'err_owner_account'
};
exports.CreateAccessToken401ResponseResultCodeEnum = {
    InvalidAccessRightsId: 'err_invalid_access_rights_id',
    AccountIsLocked: 'err_account_is_locked'
};
exports.CreateInvitation404ResponseResultCodeEnum = {
    RolesOrNotOwnedByParent: 'err_unknown_roles_or_not_owned_by_parent',
    Organisation: 'err_unknown_organisation'
};
exports.CreateOrganisation404ResponseResultCodeEnum = {
    AdditionalTemplateRoleOrInvalidOwner: 'err_unknown_additional_template_role_or_invalid_owner',
    OrganisationRoleTemplate: 'err_unknown_organisation_role_template'
};
exports.CreateOrganisation409ResponseResultCodeEnum = {
    ErrDuplicateOrganisationName: 'err_duplicate_organisation_name'
};
exports.CreateRefreshToken409ResponseResultCodeEnum = {
    ErrPasskeyNotExpired: 'err_passkey_not_expired'
};
exports.DeleteChildOrganisationRelationship404ResponseResultCodeEnum = {
    Organisation: 'err_unknown_organisation',
    Relationship: 'err_unknown_relationship'
};
exports.DeletePersonAccountRoleAssignmentInOrganisation409ResponseResultCodeEnum = {
    ErrOwnerAccount: 'err_owner_account'
};
/**
 * The authentification method, a device account has to use to aquire access tokens.
 * @export
 * @enum {string}
 */
exports.DeviceAccountAuthentificationMethod = {
    Passkey: 'passkey',
    Certificate: 'certificate'
};
exports.GetAccountResourcesInOrganisationUnsecured404ResponseResultCodesEnum = {
    Organisation: 'err_unknown_organisation',
    Account: 'err_unknown_account'
};
exports.GetPersonAccountAvatarImage409ResponseResultCodesEnum = {
    ErrInvalidMimeType: 'err_invalid_mime_type'
};
exports.GetPersonAccountRoleAssignmentsInOrganisation404ResponseResultCodeEnum = {
    Organisation: 'err_unknown_organisation',
    Relationship: 'err_unknown_relationship',
    Account: 'err_unknown_account'
};
exports.GetServiceLiveness500ResponseStatusEnum = {
    NotAlive: 'not_alive'
};
exports.GetServiceReadiness200ResponseStatusEnum = {
    Ok: 'ok'
};
exports.GetServiceReadiness500ResponseStatusEnum = {
    NotReady: 'not_ready'
};
exports.GetServiceStatus500ResponseResultCodeEnum = {
    ErrInternal: 'err_internal'
};
exports.InvitationRequestTypeEnum = {
    Organisation: 'invitation_for_organisation',
    Account: 'invitation_for_account'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Locale = {
    En: 'en',
    De: 'de'
};
exports.PasskeyResetRequestOriginEnum = {
    Parts: 'parts',
    Telematics: 'telematics'
};
/**
 * The authentification method, a person account has to use to aquire access tokens.
 * @export
 * @enum {string}
 */
exports.PersonAccountAuthentificationMethod = {
    Passkey: 'passkey',
    PasskeyAndTotp: 'passkey_and_totp'
};
/**
 * A resource type identifier
 * @export
 * @enum {string}
 */
exports.ResourceGroupEntryType = {
    Vehicle: 'vehicle'
};
/**
 * A resource proxy type identifier
 * @export
 * @enum {string}
 */
exports.ResourceProxyType = {
    Vehicle: 'vehicle'
};
/**
 * A resource type identifier
 * @export
 * @enum {string}
 */
exports.ResourceType = {
    Vehicle: 'vehicle',
    ResourceGroup: 'resource_group',
    Null: 'null'
};
/**
 * The role type when creating a role
 * @export
 * @enum {string}
 */
exports.RoleTypeCreate = {
    Standard: 'standard',
    Template: 'template',
    TemplateTemplate: 'template_template'
};
/**
 * The role type when reading roles
 * @export
 * @enum {string}
 */
exports.RoleTypeRead = {
    Root: 'root',
    Organisation: 'organisation',
    Standard: 'standard',
    Template: 'template',
    TemplateTemplate: 'template_template'
};
exports.ServiceStatusDatabaseConnectionStatusEnum = {
    Ok: 'ok',
    Error: 'error'
};
exports.ServiceStatusCertificateManagerStatusEnum = {
    Ok: 'ok',
    Error: 'error'
};
exports.ServiceStatusTokenRevocationServiceStatusEnum = {
    Started: 'started',
    StartedCacheOnly: 'started_cache_only',
    Stopped: 'stopped',
    Error: 'error'
};
exports.ServiceStatusProductionModeEnum = {
    Production: 'production',
    Staging: 'staging',
    Testing: 'testing',
    Integration: 'integration',
    Development: 'development'
};
exports.TokenRequestFailureResponseResultCodeEnum = {
    Unauthorized: 'err_unauthorized',
    AccountIsLocked: 'err_account_is_locked',
    PasskeyExpired: 'err_passkey_expired'
};
exports.UpdateOrganisationOwnership404ResponseResultCodeEnum = {
    Account: 'err_unknown_account',
    Roles: 'err_unknown_roles'
};
exports.UpdatePersonAccount409ResponseResultCodesEnum = {
    ErrCannotSelflock: 'err_cannot_selflock'
};
exports.UpdatePersonAccountAvatarImage404ResponseResultCodesEnum = {
    ErrUnknownAccount: 'err_unknown_account'
};
exports.UpdatePersonAccountAvatarImage415ResponseResultCodesEnum = {
    ErrInvalidImageSize: 'err_invalid_image_size'
};
exports.UpdateRoleAccessRights404ResponseResultCodesEnum = {
    RightsObject: 'err_unknown_rights_object',
    Role: 'err_unknown_role'
};
/**
 * AccountsApi - axios parameter creator
 * @export
 */
exports.AccountsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources. The requesting account must have sufficient rights to perform this operation:   * accounts/all, canRead   or   * accounts, canRead (in organisationId)   or   * requesting account is accountId
         * @summary getAccountAccessRights - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessRights: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getAccountAccessRights', 'accountId', accountId);
            const localVarPath = `/accounts/{accountId}/access-rights`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources.
         * @summary getAccountAccessRights_Unsecured - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessRightsUnsecured: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getAccountAccessRightsUnsecured', 'accountId', accountId);
            const localVarPath = `/internal/accounts/{accountId}/access-rights`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets PKI certificate of account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/all, canRead   or   requesting account is {accountId}
         * @summary getAccountCertificate - Get PKI certificate of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCertificate: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getAccountCertificate', 'accountId', accountId);
            const localVarPath = `/accounts/{accountId}/certificate`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsApi - functional programming interface
 * @export
 */
exports.AccountsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountsApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources. The requesting account must have sufficient rights to perform this operation:   * accounts/all, canRead   or   * accounts, canRead (in organisationId)   or   * requesting account is accountId
         * @summary getAccountAccessRights - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountAccessRights(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountAccessRights(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources.
         * @summary getAccountAccessRights_Unsecured - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountAccessRightsUnsecured(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountAccessRightsUnsecured(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets PKI certificate of account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/all, canRead   or   requesting account is {accountId}
         * @summary getAccountCertificate - Get PKI certificate of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountCertificate(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountCertificate(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsApi - factory interface
 * @export
 */
exports.AccountsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountsApiFp(configuration);
    return {
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources. The requesting account must have sufficient rights to perform this operation:   * accounts/all, canRead   or   * accounts, canRead (in organisationId)   or   * requesting account is accountId
         * @summary getAccountAccessRights - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessRights(accountId, options) {
            return localVarFp.getAccountAccessRights(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources.
         * @summary getAccountAccessRights_Unsecured - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessRightsUnsecured(accountId, options) {
            return localVarFp.getAccountAccessRightsUnsecured(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets PKI certificate of account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/all, canRead   or   requesting account is {accountId}
         * @summary getAccountCertificate - Get PKI certificate of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCertificate(accountId, options) {
            return localVarFp.getAccountCertificate(accountId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
class AccountsApi extends base_1.BaseAPI {
    /**
     * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources. The requesting account must have sufficient rights to perform this operation:   * accounts/all, canRead   or   * accounts, canRead (in organisationId)   or   * requesting account is accountId
     * @summary getAccountAccessRights - Get detailed access rights of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccountAccessRights(accountId, options) {
        return exports.AccountsApiFp(this.configuration).getAccountAccessRights(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources.
     * @summary getAccountAccessRights_Unsecured - Get detailed access rights of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccountAccessRightsUnsecured(accountId, options) {
        return exports.AccountsApiFp(this.configuration).getAccountAccessRightsUnsecured(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets PKI certificate of account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/all, canRead   or   requesting account is {accountId}
     * @summary getAccountCertificate - Get PKI certificate of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccountCertificate(accountId, options) {
        return exports.AccountsApiFp(this.configuration).getAccountCertificate(accountId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountsApi = AccountsApi;
/**
 * AccountsAccessRightsRevocationApi - axios parameter creator
 * @export
 */
exports.AccountsAccessRightsRevocationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Forces a logout for account. This method is protected through an access token that has to be provided.
         * @summary createAccountAccessRightsRevocation - Forces an account access rights revocation
         * @param {AccessRightsRevocation} accessRightsRevocation An Account revocation configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountAccessRightsRevocation: async (accessRightsRevocation, options = {}) => {
            // verify required parameter 'accessRightsRevocation' is not null or undefined
            common_1.assertParamExists('createAccountAccessRightsRevocation', 'accessRightsRevocation', accessRightsRevocation);
            const localVarPath = `/accounts/access-rights-revocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(accessRightsRevocation, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsAccessRightsRevocationApi - functional programming interface
 * @export
 */
exports.AccountsAccessRightsRevocationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountsAccessRightsRevocationApiAxiosParamCreator(configuration);
    return {
        /**
         * Forces a logout for account. This method is protected through an access token that has to be provided.
         * @summary createAccountAccessRightsRevocation - Forces an account access rights revocation
         * @param {AccessRightsRevocation} accessRightsRevocation An Account revocation configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccountAccessRightsRevocation(accessRightsRevocation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccountAccessRightsRevocation(accessRightsRevocation, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsAccessRightsRevocationApi - factory interface
 * @export
 */
exports.AccountsAccessRightsRevocationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountsAccessRightsRevocationApiFp(configuration);
    return {
        /**
         * Forces a logout for account. This method is protected through an access token that has to be provided.
         * @summary createAccountAccessRightsRevocation - Forces an account access rights revocation
         * @param {AccessRightsRevocation} accessRightsRevocation An Account revocation configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountAccessRightsRevocation(accessRightsRevocation, options) {
            return localVarFp.createAccountAccessRightsRevocation(accessRightsRevocation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsAccessRightsRevocationApi - object-oriented interface
 * @export
 * @class AccountsAccessRightsRevocationApi
 * @extends {BaseAPI}
 */
class AccountsAccessRightsRevocationApi extends base_1.BaseAPI {
    /**
     * Forces a logout for account. This method is protected through an access token that has to be provided.
     * @summary createAccountAccessRightsRevocation - Forces an account access rights revocation
     * @param {AccessRightsRevocation} accessRightsRevocation An Account revocation configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsAccessRightsRevocationApi
     */
    createAccountAccessRightsRevocation(accessRightsRevocation, options) {
        return exports.AccountsAccessRightsRevocationApiFp(this.configuration).createAccountAccessRightsRevocation(accessRightsRevocation, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountsAccessRightsRevocationApi = AccountsAccessRightsRevocationApi;
/**
 * AccountsDevicesApi - axios parameter creator
 * @export
 */
exports.AccountsDevicesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates a new device account. The account will be associated with the organisation specified in the body. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canCreate
         * @summary createDeviceAccount - Create device account
         * @param {DeviceAccountCreate} deviceAccountCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceAccount: async (deviceAccountCreate, options = {}) => {
            // verify required parameter 'deviceAccountCreate' is not null or undefined
            common_1.assertParamExists('createDeviceAccount', 'deviceAccountCreate', deviceAccountCreate);
            const localVarPath = `/accounts/devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deviceAccountCreate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes device account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canDelete
         * @summary deleteDeviceAccount - Delete device account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceAccount: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('deleteDeviceAccount', 'accountId', accountId);
            const localVarPath = `/accounts/devices/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets device account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead
         * @summary getDeviceAccount - Get device account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccount: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getDeviceAccount', 'accountId', accountId);
            const localVarPath = `/accounts/devices/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a range of device accounts from the accounts collection. This method is protected through an access token that has to be provided. The requesting account must have sufficient rights to perform this operation. The visible collection is limited to the items the requesting account is allowed to access:   accounts/devices/all, canRead
         * @summary getDeviceAccounts - Get range of device accounts
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'deviceIdRef' | 'deviceIdRef desc' | 'accountName' | 'accountName desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'deviceIdRef' | 'accountId' | 'accountName' | 'description' | 'isLocked' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccounts: async ($search, $top, $skip, $filter, $count, $orderby, $select, options = {}) => {
            const localVarPath = `/accounts/devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            if ($select) {
                localVarQueryParameter['$select'] = Array.from($select).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a range of device accounts from the accounts collection in a given organisation. This method is protected through an access token that has to be provided.  The requesting account must have sufficient rights to perform this operation:   accounts/devices (canRead)   accounts/devices/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
         * @summary getDeviceAccountsInOrganisation - Get range of device accounts in a given organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'deviceIdRef' | 'deviceIdRef desc' | 'accountName' | 'accountName desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'deviceIdRef' | 'accountId' | 'accountName' | 'description' | 'isLocked' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccountsInOrganisation: async (organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getDeviceAccountsInOrganisation', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/accounts/devices`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            if ($select) {
                localVarQueryParameter['$select'] = Array.from($select).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially updates a device account. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate
         * @summary updateDeviceAccount - Partially update device account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {DeviceAccountUpdate} deviceAccountUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceAccount: async (accountId, deviceAccountUpdate, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('updateDeviceAccount', 'accountId', accountId);
            // verify required parameter 'deviceAccountUpdate' is not null or undefined
            common_1.assertParamExists('updateDeviceAccount', 'deviceAccountUpdate', deviceAccountUpdate);
            const localVarPath = `/accounts/devices/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deviceAccountUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsDevicesApi - functional programming interface
 * @export
 */
exports.AccountsDevicesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountsDevicesApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a new device account. The account will be associated with the organisation specified in the body. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canCreate
         * @summary createDeviceAccount - Create device account
         * @param {DeviceAccountCreate} deviceAccountCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeviceAccount(deviceAccountCreate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeviceAccount(deviceAccountCreate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deletes device account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canDelete
         * @summary deleteDeviceAccount - Delete device account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeviceAccount(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeviceAccount(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets device account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead
         * @summary getDeviceAccount - Get device account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceAccount(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceAccount(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets a range of device accounts from the accounts collection. This method is protected through an access token that has to be provided. The requesting account must have sufficient rights to perform this operation. The visible collection is limited to the items the requesting account is allowed to access:   accounts/devices/all, canRead
         * @summary getDeviceAccounts - Get range of device accounts
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'deviceIdRef' | 'deviceIdRef desc' | 'accountName' | 'accountName desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'deviceIdRef' | 'accountId' | 'accountName' | 'description' | 'isLocked' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets a range of device accounts from the accounts collection in a given organisation. This method is protected through an access token that has to be provided.  The requesting account must have sufficient rights to perform this operation:   accounts/devices (canRead)   accounts/devices/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
         * @summary getDeviceAccountsInOrganisation - Get range of device accounts in a given organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'deviceIdRef' | 'deviceIdRef desc' | 'accountName' | 'accountName desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'deviceIdRef' | 'accountId' | 'accountName' | 'description' | 'isLocked' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Partially updates a device account. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate
         * @summary updateDeviceAccount - Partially update device account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {DeviceAccountUpdate} deviceAccountUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeviceAccount(accountId, deviceAccountUpdate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeviceAccount(accountId, deviceAccountUpdate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsDevicesApi - factory interface
 * @export
 */
exports.AccountsDevicesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountsDevicesApiFp(configuration);
    return {
        /**
         * Creates a new device account. The account will be associated with the organisation specified in the body. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canCreate
         * @summary createDeviceAccount - Create device account
         * @param {DeviceAccountCreate} deviceAccountCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceAccount(deviceAccountCreate, options) {
            return localVarFp.createDeviceAccount(deviceAccountCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes device account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canDelete
         * @summary deleteDeviceAccount - Delete device account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceAccount(accountId, options) {
            return localVarFp.deleteDeviceAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets device account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead
         * @summary getDeviceAccount - Get device account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccount(accountId, options) {
            return localVarFp.getDeviceAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a range of device accounts from the accounts collection. This method is protected through an access token that has to be provided. The requesting account must have sufficient rights to perform this operation. The visible collection is limited to the items the requesting account is allowed to access:   accounts/devices/all, canRead
         * @summary getDeviceAccounts - Get range of device accounts
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'deviceIdRef' | 'deviceIdRef desc' | 'accountName' | 'accountName desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'deviceIdRef' | 'accountId' | 'accountName' | 'description' | 'isLocked' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options) {
            return localVarFp.getDeviceAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a range of device accounts from the accounts collection in a given organisation. This method is protected through an access token that has to be provided.  The requesting account must have sufficient rights to perform this operation:   accounts/devices (canRead)   accounts/devices/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
         * @summary getDeviceAccountsInOrganisation - Get range of device accounts in a given organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'deviceIdRef' | 'deviceIdRef desc' | 'accountName' | 'accountName desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'deviceIdRef' | 'accountId' | 'accountName' | 'description' | 'isLocked' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options) {
            return localVarFp.getDeviceAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(axios, basePath));
        },
        /**
         * Partially updates a device account. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate
         * @summary updateDeviceAccount - Partially update device account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {DeviceAccountUpdate} deviceAccountUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceAccount(accountId, deviceAccountUpdate, options) {
            return localVarFp.updateDeviceAccount(accountId, deviceAccountUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsDevicesApi - object-oriented interface
 * @export
 * @class AccountsDevicesApi
 * @extends {BaseAPI}
 */
class AccountsDevicesApi extends base_1.BaseAPI {
    /**
     * Creates a new device account. The account will be associated with the organisation specified in the body. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canCreate
     * @summary createDeviceAccount - Create device account
     * @param {DeviceAccountCreate} deviceAccountCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesApi
     */
    createDeviceAccount(deviceAccountCreate, options) {
        return exports.AccountsDevicesApiFp(this.configuration).createDeviceAccount(deviceAccountCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes device account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canDelete
     * @summary deleteDeviceAccount - Delete device account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesApi
     */
    deleteDeviceAccount(accountId, options) {
        return exports.AccountsDevicesApiFp(this.configuration).deleteDeviceAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets device account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead
     * @summary getDeviceAccount - Get device account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesApi
     */
    getDeviceAccount(accountId, options) {
        return exports.AccountsDevicesApiFp(this.configuration).getDeviceAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a range of device accounts from the accounts collection. This method is protected through an access token that has to be provided. The requesting account must have sufficient rights to perform this operation. The visible collection is limited to the items the requesting account is allowed to access:   accounts/devices/all, canRead
     * @summary getDeviceAccounts - Get range of device accounts
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Array<'deviceIdRef' | 'deviceIdRef desc' | 'accountName' | 'accountName desc'>} [$orderby] An OData conformant $orderby string
     * @param {Array<'deviceIdRef' | 'accountId' | 'accountName' | 'description' | 'isLocked' | 'authentificationMethod'>} [$select] An OData conformant $select string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesApi
     */
    getDeviceAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options) {
        return exports.AccountsDevicesApiFp(this.configuration).getDeviceAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a range of device accounts from the accounts collection in a given organisation. This method is protected through an access token that has to be provided.  The requesting account must have sufficient rights to perform this operation:   accounts/devices (canRead)   accounts/devices/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
     * @summary getDeviceAccountsInOrganisation - Get range of device accounts in a given organisation
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Array<'deviceIdRef' | 'deviceIdRef desc' | 'accountName' | 'accountName desc'>} [$orderby] An OData conformant $orderby string
     * @param {Array<'deviceIdRef' | 'accountId' | 'accountName' | 'description' | 'isLocked' | 'authentificationMethod'>} [$select] An OData conformant $select string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesApi
     */
    getDeviceAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options) {
        return exports.AccountsDevicesApiFp(this.configuration).getDeviceAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Partially updates a device account. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate
     * @summary updateDeviceAccount - Partially update device account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {DeviceAccountUpdate} deviceAccountUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesApi
     */
    updateDeviceAccount(accountId, deviceAccountUpdate, options) {
        return exports.AccountsDevicesApiFp(this.configuration).updateDeviceAccount(accountId, deviceAccountUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountsDevicesApi = AccountsDevicesApi;
/**
 * AccountsDevicesMembershipsApi - axios parameter creator
 * @export
 */
exports.AccountsDevicesMembershipsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Add access rights for account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate   accounts/devices, canUpdate (in organisationId)
         * @summary addDeviceAccountRoleAssignmentInOrganisation - Add access rights for account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeviceAccountRoleAssignmentInOrganisation: async (accountId, organisationId, roleResourceCombination, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('addDeviceAccountRoleAssignmentInOrganisation', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('addDeviceAccountRoleAssignmentInOrganisation', 'organisationId', organisationId);
            // verify required parameter 'roleResourceCombination' is not null or undefined
            common_1.assertParamExists('addDeviceAccountRoleAssignmentInOrganisation', 'roleResourceCombination', roleResourceCombination);
            const localVarPath = `/accounts/devices/{accountId}/memberships/{organisationId}/role-assignments`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleResourceCombination, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a membership of account {accountId}. The requesting account must have sufficient rights to perform this operation.
         * @summary createDeviceAccountMembership - Create a membership of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {AccountMembershipCreate} accountMembershipCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceAccountMembership: async (accountId, accountMembershipCreate, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('createDeviceAccountMembership', 'accountId', accountId);
            // verify required parameter 'accountMembershipCreate' is not null or undefined
            common_1.assertParamExists('createDeviceAccountMembership', 'accountMembershipCreate', accountMembershipCreate);
            const localVarPath = `/accounts/devices/{accountId}/memberships`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(accountMembershipCreate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/devices/all, canUpdate    or    * account_memberships, canDelete (in organsationId)
         * @summary deleteDeviceAccountMembership - Delete membership in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceAccountMembership: async (accountId, organisationId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('deleteDeviceAccountMembership', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('deleteDeviceAccountMembership', 'organisationId', organisationId);
            const localVarPath = `/accounts/devices/{accountId}/memberships/{organisationId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes access rights of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate   accounts/devices, canUpdate (in organisationId)
         * @summary deleteDeviceAccountRoleAssignmentInOrganisation - Delete access rights of account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceAccountRoleAssignmentInOrganisation: async (accountId, organisationId, roleResourceCombination, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('deleteDeviceAccountRoleAssignmentInOrganisation', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('deleteDeviceAccountRoleAssignmentInOrganisation', 'organisationId', organisationId);
            // verify required parameter 'roleResourceCombination' is not null or undefined
            common_1.assertParamExists('deleteDeviceAccountRoleAssignmentInOrganisation', 'roleResourceCombination', roleResourceCombination);
            const localVarPath = `/accounts/devices/{accountId}/memberships/{organisationId}/role-assignments`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleResourceCombination, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets organisations the account {accountId} is member of. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead
         * @summary getDeviceAccountMemberships - Get organisations the account {accountId} is member of
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccountMemberships: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getDeviceAccountMemberships', 'accountId', accountId);
            const localVarPath = `/accounts/devices/{accountId}/memberships`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get role assignments in organisation {organisationId} the account {accountId} has. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead   accounts/devices, canRead (in organisationId)
         * @summary getDeviceAccountRoleAssignmentsInOrganisation - Get role assingments in organisation {organisationId} the account {accountId} has
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccountRoleAssignmentsInOrganisation: async (accountId, organisationId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getDeviceAccountRoleAssignmentsInOrganisation', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getDeviceAccountRoleAssignmentsInOrganisation', 'organisationId', organisationId);
            const localVarPath = `/accounts/devices/{accountId}/memberships/{organisationId}/role-assignments`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsDevicesMembershipsApi - functional programming interface
 * @export
 */
exports.AccountsDevicesMembershipsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountsDevicesMembershipsApiAxiosParamCreator(configuration);
    return {
        /**
         * Add access rights for account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate   accounts/devices, canUpdate (in organisationId)
         * @summary addDeviceAccountRoleAssignmentInOrganisation - Add access rights for account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Creates a membership of account {accountId}. The requesting account must have sufficient rights to perform this operation.
         * @summary createDeviceAccountMembership - Create a membership of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {AccountMembershipCreate} accountMembershipCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeviceAccountMembership(accountId, accountMembershipCreate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeviceAccountMembership(accountId, accountMembershipCreate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deletes membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/devices/all, canUpdate    or    * account_memberships, canDelete (in organsationId)
         * @summary deleteDeviceAccountMembership - Delete membership in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeviceAccountMembership(accountId, organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeviceAccountMembership(accountId, organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deletes access rights of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate   accounts/devices, canUpdate (in organisationId)
         * @summary deleteDeviceAccountRoleAssignmentInOrganisation - Delete access rights of account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets organisations the account {accountId} is member of. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead
         * @summary getDeviceAccountMemberships - Get organisations the account {accountId} is member of
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceAccountMemberships(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceAccountMemberships(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get role assignments in organisation {organisationId} the account {accountId} has. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead   accounts/devices, canRead (in organisationId)
         * @summary getDeviceAccountRoleAssignmentsInOrganisation - Get role assingments in organisation {organisationId} the account {accountId} has
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceAccountRoleAssignmentsInOrganisation(accountId, organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceAccountRoleAssignmentsInOrganisation(accountId, organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsDevicesMembershipsApi - factory interface
 * @export
 */
exports.AccountsDevicesMembershipsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountsDevicesMembershipsApiFp(configuration);
    return {
        /**
         * Add access rights for account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate   accounts/devices, canUpdate (in organisationId)
         * @summary addDeviceAccountRoleAssignmentInOrganisation - Add access rights for account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
            return localVarFp.addDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a membership of account {accountId}. The requesting account must have sufficient rights to perform this operation.
         * @summary createDeviceAccountMembership - Create a membership of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {AccountMembershipCreate} accountMembershipCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceAccountMembership(accountId, accountMembershipCreate, options) {
            return localVarFp.createDeviceAccountMembership(accountId, accountMembershipCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/devices/all, canUpdate    or    * account_memberships, canDelete (in organsationId)
         * @summary deleteDeviceAccountMembership - Delete membership in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceAccountMembership(accountId, organisationId, options) {
            return localVarFp.deleteDeviceAccountMembership(accountId, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes access rights of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate   accounts/devices, canUpdate (in organisationId)
         * @summary deleteDeviceAccountRoleAssignmentInOrganisation - Delete access rights of account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
            return localVarFp.deleteDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets organisations the account {accountId} is member of. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead
         * @summary getDeviceAccountMemberships - Get organisations the account {accountId} is member of
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccountMemberships(accountId, options) {
            return localVarFp.getDeviceAccountMemberships(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get role assignments in organisation {organisationId} the account {accountId} has. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead   accounts/devices, canRead (in organisationId)
         * @summary getDeviceAccountRoleAssignmentsInOrganisation - Get role assingments in organisation {organisationId} the account {accountId} has
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceAccountRoleAssignmentsInOrganisation(accountId, organisationId, options) {
            return localVarFp.getDeviceAccountRoleAssignmentsInOrganisation(accountId, organisationId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsDevicesMembershipsApi - object-oriented interface
 * @export
 * @class AccountsDevicesMembershipsApi
 * @extends {BaseAPI}
 */
class AccountsDevicesMembershipsApi extends base_1.BaseAPI {
    /**
     * Add access rights for account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate   accounts/devices, canUpdate (in organisationId)
     * @summary addDeviceAccountRoleAssignmentInOrganisation - Add access rights for account {accountId} in organisation {organisationId}
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {RoleResourceCombination} roleResourceCombination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesMembershipsApi
     */
    addDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
        return exports.AccountsDevicesMembershipsApiFp(this.configuration).addDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a membership of account {accountId}. The requesting account must have sufficient rights to perform this operation.
     * @summary createDeviceAccountMembership - Create a membership of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {AccountMembershipCreate} accountMembershipCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesMembershipsApi
     */
    createDeviceAccountMembership(accountId, accountMembershipCreate, options) {
        return exports.AccountsDevicesMembershipsApiFp(this.configuration).createDeviceAccountMembership(accountId, accountMembershipCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/devices/all, canUpdate    or    * account_memberships, canDelete (in organsationId)
     * @summary deleteDeviceAccountMembership - Delete membership in organisation {organisationId} of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesMembershipsApi
     */
    deleteDeviceAccountMembership(accountId, organisationId, options) {
        return exports.AccountsDevicesMembershipsApiFp(this.configuration).deleteDeviceAccountMembership(accountId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes access rights of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canUpdate   accounts/devices, canUpdate (in organisationId)
     * @summary deleteDeviceAccountRoleAssignmentInOrganisation - Delete access rights of account {accountId} in organisation {organisationId}
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {RoleResourceCombination} roleResourceCombination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesMembershipsApi
     */
    deleteDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
        return exports.AccountsDevicesMembershipsApiFp(this.configuration).deleteDeviceAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets organisations the account {accountId} is member of. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead
     * @summary getDeviceAccountMemberships - Get organisations the account {accountId} is member of
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesMembershipsApi
     */
    getDeviceAccountMemberships(accountId, options) {
        return exports.AccountsDevicesMembershipsApiFp(this.configuration).getDeviceAccountMemberships(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get role assignments in organisation {organisationId} the account {accountId} has. The requesting account must have sufficient rights to perform this operation:   accounts/devices/all, canRead   accounts/devices, canRead (in organisationId)
     * @summary getDeviceAccountRoleAssignmentsInOrganisation - Get role assingments in organisation {organisationId} the account {accountId} has
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsDevicesMembershipsApi
     */
    getDeviceAccountRoleAssignmentsInOrganisation(accountId, organisationId, options) {
        return exports.AccountsDevicesMembershipsApiFp(this.configuration).getDeviceAccountRoleAssignmentsInOrganisation(accountId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountsDevicesMembershipsApi = AccountsDevicesMembershipsApi;
/**
 * AccountsPasskeyApi - axios parameter creator
 * @export
 */
exports.AccountsPasskeyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Updates the passkey of the account {accountId}. This method is protected through an access token that has to be provided. The requesting account must have sufficient access rights:   accounts/passkeys/all, canUpdate. NB: This method updates an arbitrary account and requires special access rights. It is not meant to be used by accounts who want to re-set their own passkeys or by organisation admins who want to trigger a passkey reset for a member of their organisation. Use updatePasskey() or createPasskeyResetRequest() instead
         * @summary updateAccountPasskey - Update the passkey of {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {PasskeyChangeSettings} passkeyChangeSettings Old and new passkey of account {accountId}
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountPasskey: async (accountId, passkeyChangeSettings, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('updateAccountPasskey', 'accountId', accountId);
            // verify required parameter 'passkeyChangeSettings' is not null or undefined
            common_1.assertParamExists('updateAccountPasskey', 'passkeyChangeSettings', passkeyChangeSettings);
            const localVarPath = `/accounts/{accountId}/passkey`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(passkeyChangeSettings, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsPasskeyApi - functional programming interface
 * @export
 */
exports.AccountsPasskeyApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountsPasskeyApiAxiosParamCreator(configuration);
    return {
        /**
         * Updates the passkey of the account {accountId}. This method is protected through an access token that has to be provided. The requesting account must have sufficient access rights:   accounts/passkeys/all, canUpdate. NB: This method updates an arbitrary account and requires special access rights. It is not meant to be used by accounts who want to re-set their own passkeys or by organisation admins who want to trigger a passkey reset for a member of their organisation. Use updatePasskey() or createPasskeyResetRequest() instead
         * @summary updateAccountPasskey - Update the passkey of {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {PasskeyChangeSettings} passkeyChangeSettings Old and new passkey of account {accountId}
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountPasskey(accountId, passkeyChangeSettings, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountPasskey(accountId, passkeyChangeSettings, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsPasskeyApi - factory interface
 * @export
 */
exports.AccountsPasskeyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountsPasskeyApiFp(configuration);
    return {
        /**
         * Updates the passkey of the account {accountId}. This method is protected through an access token that has to be provided. The requesting account must have sufficient access rights:   accounts/passkeys/all, canUpdate. NB: This method updates an arbitrary account and requires special access rights. It is not meant to be used by accounts who want to re-set their own passkeys or by organisation admins who want to trigger a passkey reset for a member of their organisation. Use updatePasskey() or createPasskeyResetRequest() instead
         * @summary updateAccountPasskey - Update the passkey of {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {PasskeyChangeSettings} passkeyChangeSettings Old and new passkey of account {accountId}
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountPasskey(accountId, passkeyChangeSettings, options) {
            return localVarFp.updateAccountPasskey(accountId, passkeyChangeSettings, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsPasskeyApi - object-oriented interface
 * @export
 * @class AccountsPasskeyApi
 * @extends {BaseAPI}
 */
class AccountsPasskeyApi extends base_1.BaseAPI {
    /**
     * Updates the passkey of the account {accountId}. This method is protected through an access token that has to be provided. The requesting account must have sufficient access rights:   accounts/passkeys/all, canUpdate. NB: This method updates an arbitrary account and requires special access rights. It is not meant to be used by accounts who want to re-set their own passkeys or by organisation admins who want to trigger a passkey reset for a member of their organisation. Use updatePasskey() or createPasskeyResetRequest() instead
     * @summary updateAccountPasskey - Update the passkey of {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {PasskeyChangeSettings} passkeyChangeSettings Old and new passkey of account {accountId}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPasskeyApi
     */
    updateAccountPasskey(accountId, passkeyChangeSettings, options) {
        return exports.AccountsPasskeyApiFp(this.configuration).updateAccountPasskey(accountId, passkeyChangeSettings, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountsPasskeyApi = AccountsPasskeyApi;
/**
 * AccountsPersonsApi - axios parameter creator
 * @export
 */
exports.AccountsPersonsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Service method for admin purposes. Creates a new person or device account. The account will be associated with the organisation specified in the body. An intial membership for that account can be specified. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canCreate
         * @summary createPersonAccount - Create person account
         * @param {PersonAccountCreate} personAccountCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonAccount: async (personAccountCreate, options = {}) => {
            // verify required parameter 'personAccountCreate' is not null or undefined
            common_1.assertParamExists('createPersonAccount', 'personAccountCreate', personAccountCreate);
            const localVarPath = `/accounts/persons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(personAccountCreate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes person account {accountId}. The requesting account must have sufficient rights to perform this operation:   account must be the requesting account   or   accounts/organisations/all, canDelete
         * @summary deletePersonAccount - Delete person account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonAccount: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('deletePersonAccount', 'accountId', accountId);
            const localVarPath = `/accounts/persons/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the avatar image of the account.  Requesting account must have sufficiant access rights:   accounts/persons/all, canUpdate   or   the requesting account is accountId
         * @summary deletePersonAccountAvatarImage - Deletes the avatar image of the account
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonAccountAvatarImage: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('deletePersonAccountAvatarImage', 'accountId', accountId);
            const localVarPath = `/accounts/persons/{accountId}/avatar`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets person account {accountId}. The requesting account must have sufficient rights to perform this operation:   account must be the requesting account   or   accounts/organisations/all, canRead
         * @summary getPersonAccount - Get person account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccount: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getPersonAccount', 'accountId', accountId);
            const localVarPath = `/accounts/persons/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the avatar image of the account.  A signed URL signature as aquired via the account data must be provided.  The `refresh` query parameter can be set to an arbitrary value which is not evaluated in the server. This can be used to alter the URL used in a caching browser to force a reload.
         * @summary getPersonAccountAvatarImage - Return the avatar image of the account
         * @param {string} accountId The ID of the account resource
         * @param {string} signature A signature token for signed URLs
         * @param {string} [refresh] An
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccountAvatarImage: async (accountId, signature, refresh, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getPersonAccountAvatarImage', 'accountId', accountId);
            // verify required parameter 'signature' is not null or undefined
            common_1.assertParamExists('getPersonAccountAvatarImage', 'signature', signature);
            const localVarPath = `/accounts/persons/{accountId}/avatar`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }
            if (refresh !== undefined) {
                localVarQueryParameter['refresh'] = refresh;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a range of person accounts from the accounts collection. This method is protected through an access token that has to be provided. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all
         * @summary getPersonAccounts - Get range of person accounts
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'accountType' | 'accountType desc' | 'accountName' | 'accountName desc' | 'firstName' | 'firstName desc' | 'lastName' | 'lastName desc' | 'isLocked' | 'isLocked desc' | 'phoneNumber' | 'phoneNumber desc' | 'mainOrganisationName' | 'mainOrganisationName desc' | 'mainOrganisationRoleDescription' | 'mainOrganisationRoleDescription desc' | 'authentificationMethod' | 'authentificationMethod desc' | 'createTimestamp' | 'createTimestamp desc' | 'lastRefreshTokenCreateTimestamp' | 'lastRefreshTokenCreateTimestamp desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'accountId' | 'firstName' | 'lastName' | 'accountName' | 'isLocked' | 'phoneNumber' | 'description' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccounts: async ($search, $top, $skip, $filter, $count, $orderby, $select, options = {}) => {
            const localVarPath = `/accounts/persons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            if ($select) {
                localVarQueryParameter['$select'] = Array.from($select).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a range of person accounts from the accounts collection in a given organisation. This method is protected through an access token that has to be provided.  The requesting account must have sufficient rights to perform this operation:   accounts/persons canRead (in {organisationId})   accounts/persons/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
         * @summary getPersonAccountsInOrganisation - Get range of person accounts in a given organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'accountType' | 'accountType desc' | 'accountName' | 'accountName desc' | 'firstName' | 'firstName desc' | 'lastName' | 'lastName desc' | 'isLocked' | 'isLocked desc' | 'phoneNumber' | 'phoneNumber desc' | 'authentificationMethod' | 'authentificationMethod desc' | 'relationCreateTimestamp' | 'relationCreateTimestamp desc' | 'isMembershipLocked' | 'isMembershipLocked desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'accountId' | 'firstName' | 'lastName' | 'accountName' | 'isLocked' | 'phoneNumber' | 'description' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccountsInOrganisation: async (organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getPersonAccountsInOrganisation', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/accounts/persons`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            if ($select) {
                localVarQueryParameter['$select'] = Array.from($select).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially updates a person account. The requesting account must have sufficient rights to perform this operation:    * account must be the requesting account   or   * accounts/persons/all, canUpdate    **An account cannot lock itself**
         * @summary updatePersonAccount - Partially update person account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {PersonAccountUpdate} personAccountUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonAccount: async (accountId, personAccountUpdate, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('updatePersonAccount', 'accountId', accountId);
            // verify required parameter 'personAccountUpdate' is not null or undefined
            common_1.assertParamExists('updatePersonAccount', 'personAccountUpdate', personAccountUpdate);
            const localVarPath = `/accounts/persons/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(personAccountUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the avatar image of the account.  The image must be jpg or png, not larger than 16MB. It will be resized to 600x600 pixels while preserving its aspect ration. Images smaller than 600x600 will not be resized but centered within the resulting 600x600 image.  The resulting image is `image/png`.  Requesting account must have sufficiant access rights:   accounts/persons/all, canUpdate   or   the requesting account is accountId
         * @summary updatePersonAccountAvatarImage - Updates the avatar image of the account
         * @param {string} accountId The ID of the account resource
         * @param {UpdatePersonAccountAvatarImageRequest} updatePersonAccountAvatarImageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonAccountAvatarImage: async (accountId, updatePersonAccountAvatarImageRequest, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('updatePersonAccountAvatarImage', 'accountId', accountId);
            // verify required parameter 'updatePersonAccountAvatarImageRequest' is not null or undefined
            common_1.assertParamExists('updatePersonAccountAvatarImage', 'updatePersonAccountAvatarImageRequest', updatePersonAccountAvatarImageRequest);
            const localVarPath = `/accounts/persons/{accountId}/avatar`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updatePersonAccountAvatarImageRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsPersonsApi - functional programming interface
 * @export
 */
exports.AccountsPersonsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountsPersonsApiAxiosParamCreator(configuration);
    return {
        /**
         * Service method for admin purposes. Creates a new person or device account. The account will be associated with the organisation specified in the body. An intial membership for that account can be specified. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canCreate
         * @summary createPersonAccount - Create person account
         * @param {PersonAccountCreate} personAccountCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPersonAccount(personAccountCreate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPersonAccount(personAccountCreate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deletes person account {accountId}. The requesting account must have sufficient rights to perform this operation:   account must be the requesting account   or   accounts/organisations/all, canDelete
         * @summary deletePersonAccount - Delete person account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePersonAccount(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePersonAccount(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deletes the avatar image of the account.  Requesting account must have sufficiant access rights:   accounts/persons/all, canUpdate   or   the requesting account is accountId
         * @summary deletePersonAccountAvatarImage - Deletes the avatar image of the account
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePersonAccountAvatarImage(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePersonAccountAvatarImage(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets person account {accountId}. The requesting account must have sufficient rights to perform this operation:   account must be the requesting account   or   accounts/organisations/all, canRead
         * @summary getPersonAccount - Get person account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonAccount(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonAccount(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Return the avatar image of the account.  A signed URL signature as aquired via the account data must be provided.  The `refresh` query parameter can be set to an arbitrary value which is not evaluated in the server. This can be used to alter the URL used in a caching browser to force a reload.
         * @summary getPersonAccountAvatarImage - Return the avatar image of the account
         * @param {string} accountId The ID of the account resource
         * @param {string} signature A signature token for signed URLs
         * @param {string} [refresh] An
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonAccountAvatarImage(accountId, signature, refresh, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonAccountAvatarImage(accountId, signature, refresh, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets a range of person accounts from the accounts collection. This method is protected through an access token that has to be provided. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all
         * @summary getPersonAccounts - Get range of person accounts
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'accountType' | 'accountType desc' | 'accountName' | 'accountName desc' | 'firstName' | 'firstName desc' | 'lastName' | 'lastName desc' | 'isLocked' | 'isLocked desc' | 'phoneNumber' | 'phoneNumber desc' | 'mainOrganisationName' | 'mainOrganisationName desc' | 'mainOrganisationRoleDescription' | 'mainOrganisationRoleDescription desc' | 'authentificationMethod' | 'authentificationMethod desc' | 'createTimestamp' | 'createTimestamp desc' | 'lastRefreshTokenCreateTimestamp' | 'lastRefreshTokenCreateTimestamp desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'accountId' | 'firstName' | 'lastName' | 'accountName' | 'isLocked' | 'phoneNumber' | 'description' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets a range of person accounts from the accounts collection in a given organisation. This method is protected through an access token that has to be provided.  The requesting account must have sufficient rights to perform this operation:   accounts/persons canRead (in {organisationId})   accounts/persons/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
         * @summary getPersonAccountsInOrganisation - Get range of person accounts in a given organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'accountType' | 'accountType desc' | 'accountName' | 'accountName desc' | 'firstName' | 'firstName desc' | 'lastName' | 'lastName desc' | 'isLocked' | 'isLocked desc' | 'phoneNumber' | 'phoneNumber desc' | 'authentificationMethod' | 'authentificationMethod desc' | 'relationCreateTimestamp' | 'relationCreateTimestamp desc' | 'isMembershipLocked' | 'isMembershipLocked desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'accountId' | 'firstName' | 'lastName' | 'accountName' | 'isLocked' | 'phoneNumber' | 'description' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Partially updates a person account. The requesting account must have sufficient rights to perform this operation:    * account must be the requesting account   or   * accounts/persons/all, canUpdate    **An account cannot lock itself**
         * @summary updatePersonAccount - Partially update person account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {PersonAccountUpdate} personAccountUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonAccount(accountId, personAccountUpdate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonAccount(accountId, personAccountUpdate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Updates the avatar image of the account.  The image must be jpg or png, not larger than 16MB. It will be resized to 600x600 pixels while preserving its aspect ration. Images smaller than 600x600 will not be resized but centered within the resulting 600x600 image.  The resulting image is `image/png`.  Requesting account must have sufficiant access rights:   accounts/persons/all, canUpdate   or   the requesting account is accountId
         * @summary updatePersonAccountAvatarImage - Updates the avatar image of the account
         * @param {string} accountId The ID of the account resource
         * @param {UpdatePersonAccountAvatarImageRequest} updatePersonAccountAvatarImageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonAccountAvatarImage(accountId, updatePersonAccountAvatarImageRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonAccountAvatarImage(accountId, updatePersonAccountAvatarImageRequest, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsPersonsApi - factory interface
 * @export
 */
exports.AccountsPersonsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountsPersonsApiFp(configuration);
    return {
        /**
         * Service method for admin purposes. Creates a new person or device account. The account will be associated with the organisation specified in the body. An intial membership for that account can be specified. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canCreate
         * @summary createPersonAccount - Create person account
         * @param {PersonAccountCreate} personAccountCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonAccount(personAccountCreate, options) {
            return localVarFp.createPersonAccount(personAccountCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes person account {accountId}. The requesting account must have sufficient rights to perform this operation:   account must be the requesting account   or   accounts/organisations/all, canDelete
         * @summary deletePersonAccount - Delete person account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonAccount(accountId, options) {
            return localVarFp.deletePersonAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the avatar image of the account.  Requesting account must have sufficiant access rights:   accounts/persons/all, canUpdate   or   the requesting account is accountId
         * @summary deletePersonAccountAvatarImage - Deletes the avatar image of the account
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonAccountAvatarImage(accountId, options) {
            return localVarFp.deletePersonAccountAvatarImage(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets person account {accountId}. The requesting account must have sufficient rights to perform this operation:   account must be the requesting account   or   accounts/organisations/all, canRead
         * @summary getPersonAccount - Get person account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccount(accountId, options) {
            return localVarFp.getPersonAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the avatar image of the account.  A signed URL signature as aquired via the account data must be provided.  The `refresh` query parameter can be set to an arbitrary value which is not evaluated in the server. This can be used to alter the URL used in a caching browser to force a reload.
         * @summary getPersonAccountAvatarImage - Return the avatar image of the account
         * @param {string} accountId The ID of the account resource
         * @param {string} signature A signature token for signed URLs
         * @param {string} [refresh] An
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccountAvatarImage(accountId, signature, refresh, options) {
            return localVarFp.getPersonAccountAvatarImage(accountId, signature, refresh, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a range of person accounts from the accounts collection. This method is protected through an access token that has to be provided. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all
         * @summary getPersonAccounts - Get range of person accounts
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'accountType' | 'accountType desc' | 'accountName' | 'accountName desc' | 'firstName' | 'firstName desc' | 'lastName' | 'lastName desc' | 'isLocked' | 'isLocked desc' | 'phoneNumber' | 'phoneNumber desc' | 'mainOrganisationName' | 'mainOrganisationName desc' | 'mainOrganisationRoleDescription' | 'mainOrganisationRoleDescription desc' | 'authentificationMethod' | 'authentificationMethod desc' | 'createTimestamp' | 'createTimestamp desc' | 'lastRefreshTokenCreateTimestamp' | 'lastRefreshTokenCreateTimestamp desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'accountId' | 'firstName' | 'lastName' | 'accountName' | 'isLocked' | 'phoneNumber' | 'description' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options) {
            return localVarFp.getPersonAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a range of person accounts from the accounts collection in a given organisation. This method is protected through an access token that has to be provided.  The requesting account must have sufficient rights to perform this operation:   accounts/persons canRead (in {organisationId})   accounts/persons/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
         * @summary getPersonAccountsInOrganisation - Get range of person accounts in a given organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'accountType' | 'accountType desc' | 'accountName' | 'accountName desc' | 'firstName' | 'firstName desc' | 'lastName' | 'lastName desc' | 'isLocked' | 'isLocked desc' | 'phoneNumber' | 'phoneNumber desc' | 'authentificationMethod' | 'authentificationMethod desc' | 'relationCreateTimestamp' | 'relationCreateTimestamp desc' | 'isMembershipLocked' | 'isMembershipLocked desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'accountId' | 'firstName' | 'lastName' | 'accountName' | 'isLocked' | 'phoneNumber' | 'description' | 'authentificationMethod'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options) {
            return localVarFp.getPersonAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(axios, basePath));
        },
        /**
         * Partially updates a person account. The requesting account must have sufficient rights to perform this operation:    * account must be the requesting account   or   * accounts/persons/all, canUpdate    **An account cannot lock itself**
         * @summary updatePersonAccount - Partially update person account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {PersonAccountUpdate} personAccountUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonAccount(accountId, personAccountUpdate, options) {
            return localVarFp.updatePersonAccount(accountId, personAccountUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the avatar image of the account.  The image must be jpg or png, not larger than 16MB. It will be resized to 600x600 pixels while preserving its aspect ration. Images smaller than 600x600 will not be resized but centered within the resulting 600x600 image.  The resulting image is `image/png`.  Requesting account must have sufficiant access rights:   accounts/persons/all, canUpdate   or   the requesting account is accountId
         * @summary updatePersonAccountAvatarImage - Updates the avatar image of the account
         * @param {string} accountId The ID of the account resource
         * @param {UpdatePersonAccountAvatarImageRequest} updatePersonAccountAvatarImageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonAccountAvatarImage(accountId, updatePersonAccountAvatarImageRequest, options) {
            return localVarFp.updatePersonAccountAvatarImage(accountId, updatePersonAccountAvatarImageRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsPersonsApi - object-oriented interface
 * @export
 * @class AccountsPersonsApi
 * @extends {BaseAPI}
 */
class AccountsPersonsApi extends base_1.BaseAPI {
    /**
     * Service method for admin purposes. Creates a new person or device account. The account will be associated with the organisation specified in the body. An intial membership for that account can be specified. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canCreate
     * @summary createPersonAccount - Create person account
     * @param {PersonAccountCreate} personAccountCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsApi
     */
    createPersonAccount(personAccountCreate, options) {
        return exports.AccountsPersonsApiFp(this.configuration).createPersonAccount(personAccountCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes person account {accountId}. The requesting account must have sufficient rights to perform this operation:   account must be the requesting account   or   accounts/organisations/all, canDelete
     * @summary deletePersonAccount - Delete person account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsApi
     */
    deletePersonAccount(accountId, options) {
        return exports.AccountsPersonsApiFp(this.configuration).deletePersonAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the avatar image of the account.  Requesting account must have sufficiant access rights:   accounts/persons/all, canUpdate   or   the requesting account is accountId
     * @summary deletePersonAccountAvatarImage - Deletes the avatar image of the account
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsApi
     */
    deletePersonAccountAvatarImage(accountId, options) {
        return exports.AccountsPersonsApiFp(this.configuration).deletePersonAccountAvatarImage(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets person account {accountId}. The requesting account must have sufficient rights to perform this operation:   account must be the requesting account   or   accounts/organisations/all, canRead
     * @summary getPersonAccount - Get person account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsApi
     */
    getPersonAccount(accountId, options) {
        return exports.AccountsPersonsApiFp(this.configuration).getPersonAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return the avatar image of the account.  A signed URL signature as aquired via the account data must be provided.  The `refresh` query parameter can be set to an arbitrary value which is not evaluated in the server. This can be used to alter the URL used in a caching browser to force a reload.
     * @summary getPersonAccountAvatarImage - Return the avatar image of the account
     * @param {string} accountId The ID of the account resource
     * @param {string} signature A signature token for signed URLs
     * @param {string} [refresh] An
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsApi
     */
    getPersonAccountAvatarImage(accountId, signature, refresh, options) {
        return exports.AccountsPersonsApiFp(this.configuration).getPersonAccountAvatarImage(accountId, signature, refresh, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a range of person accounts from the accounts collection. This method is protected through an access token that has to be provided. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all
     * @summary getPersonAccounts - Get range of person accounts
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Array<'accountType' | 'accountType desc' | 'accountName' | 'accountName desc' | 'firstName' | 'firstName desc' | 'lastName' | 'lastName desc' | 'isLocked' | 'isLocked desc' | 'phoneNumber' | 'phoneNumber desc' | 'mainOrganisationName' | 'mainOrganisationName desc' | 'mainOrganisationRoleDescription' | 'mainOrganisationRoleDescription desc' | 'authentificationMethod' | 'authentificationMethod desc' | 'createTimestamp' | 'createTimestamp desc' | 'lastRefreshTokenCreateTimestamp' | 'lastRefreshTokenCreateTimestamp desc'>} [$orderby] An OData conformant $orderby string
     * @param {Array<'accountId' | 'firstName' | 'lastName' | 'accountName' | 'isLocked' | 'phoneNumber' | 'description' | 'authentificationMethod'>} [$select] An OData conformant $select string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsApi
     */
    getPersonAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options) {
        return exports.AccountsPersonsApiFp(this.configuration).getPersonAccounts($search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a range of person accounts from the accounts collection in a given organisation. This method is protected through an access token that has to be provided.  The requesting account must have sufficient rights to perform this operation:   accounts/persons canRead (in {organisationId})   accounts/persons/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
     * @summary getPersonAccountsInOrganisation - Get range of person accounts in a given organisation
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Array<'accountType' | 'accountType desc' | 'accountName' | 'accountName desc' | 'firstName' | 'firstName desc' | 'lastName' | 'lastName desc' | 'isLocked' | 'isLocked desc' | 'phoneNumber' | 'phoneNumber desc' | 'authentificationMethod' | 'authentificationMethod desc' | 'relationCreateTimestamp' | 'relationCreateTimestamp desc' | 'isMembershipLocked' | 'isMembershipLocked desc'>} [$orderby] An OData conformant $orderby string
     * @param {Array<'accountId' | 'firstName' | 'lastName' | 'accountName' | 'isLocked' | 'phoneNumber' | 'description' | 'authentificationMethod'>} [$select] An OData conformant $select string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsApi
     */
    getPersonAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options) {
        return exports.AccountsPersonsApiFp(this.configuration).getPersonAccountsInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Partially updates a person account. The requesting account must have sufficient rights to perform this operation:    * account must be the requesting account   or   * accounts/persons/all, canUpdate    **An account cannot lock itself**
     * @summary updatePersonAccount - Partially update person account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {PersonAccountUpdate} personAccountUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsApi
     */
    updatePersonAccount(accountId, personAccountUpdate, options) {
        return exports.AccountsPersonsApiFp(this.configuration).updatePersonAccount(accountId, personAccountUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the avatar image of the account.  The image must be jpg or png, not larger than 16MB. It will be resized to 600x600 pixels while preserving its aspect ration. Images smaller than 600x600 will not be resized but centered within the resulting 600x600 image.  The resulting image is `image/png`.  Requesting account must have sufficiant access rights:   accounts/persons/all, canUpdate   or   the requesting account is accountId
     * @summary updatePersonAccountAvatarImage - Updates the avatar image of the account
     * @param {string} accountId The ID of the account resource
     * @param {UpdatePersonAccountAvatarImageRequest} updatePersonAccountAvatarImageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsApi
     */
    updatePersonAccountAvatarImage(accountId, updatePersonAccountAvatarImageRequest, options) {
        return exports.AccountsPersonsApiFp(this.configuration).updatePersonAccountAvatarImage(accountId, updatePersonAccountAvatarImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountsPersonsApi = AccountsPersonsApi;
/**
 * AccountsPersonsMembershipsApi - axios parameter creator
 * @export
 */
exports.AccountsPersonsMembershipsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Add access rights for account {accountId} in organisation {organisationId}. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights and cannot be altered. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canUpdate   accounts/persons, canUpdate (in {organisationId})
         * @summary addPersonAccountRoleAssignmentInOrganisation - Add access rights for account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPersonAccountRoleAssignmentInOrganisation: async (accountId, organisationId, roleResourceCombination, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('addPersonAccountRoleAssignmentInOrganisation', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('addPersonAccountRoleAssignmentInOrganisation', 'organisationId', organisationId);
            // verify required parameter 'roleResourceCombination' is not null or undefined
            common_1.assertParamExists('addPersonAccountRoleAssignmentInOrganisation', 'roleResourceCombination', roleResourceCombination);
            const localVarPath = `/accounts/persons/{accountId}/memberships/{organisationId}/role-assignments`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleResourceCombination, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a membership of account {accountId}. The requesting account must have sufficient rights to perform this operation:   account_memberships, canCreate
         * @summary createPersonAccountMembership - Create a membership of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {AccountMembershipCreate} accountMembershipCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonAccountMembership: async (accountId, accountMembershipCreate, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('createPersonAccountMembership', 'accountId', accountId);
            // verify required parameter 'accountMembershipCreate' is not null or undefined
            common_1.assertParamExists('createPersonAccountMembership', 'accountMembershipCreate', accountMembershipCreate);
            const localVarPath = `/accounts/persons/{accountId}/memberships`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(accountMembershipCreate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * account_memberships, canDelete (in organisationId)
         * @summary deletePersonAccountMembership - Delete membership in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonAccountMembership: async (accountId, organisationId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('deletePersonAccountMembership', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('deletePersonAccountMembership', 'organisationId', organisationId);
            const localVarPath = `/accounts/persons/{accountId}/memberships/{organisationId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes access rights of account {accountId} in organisation {organisationId}. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights and cannot be altered. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canUpdate   accounts/persons, canUpdate (in {organisationId})
         * @summary deletePersonAccountRoleAssignmentInOrganisation - Delete access rights of account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonAccountRoleAssignmentInOrganisation: async (accountId, organisationId, roleResourceCombination, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('deletePersonAccountRoleAssignmentInOrganisation', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('deletePersonAccountRoleAssignmentInOrganisation', 'organisationId', organisationId);
            // verify required parameter 'roleResourceCombination' is not null or undefined
            common_1.assertParamExists('deletePersonAccountRoleAssignmentInOrganisation', 'roleResourceCombination', roleResourceCombination);
            const localVarPath = `/accounts/persons/{accountId}/memberships/{organisationId}/role-assignments`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleResourceCombination, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets organisations the account {accountId} is member of. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canRead    or    * requesting account is {accountId}
         * @summary getPersonAccountMemberships - Get organisations the account {accountId} is member of
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccountMemberships: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getPersonAccountMemberships', 'accountId', accountId);
            const localVarPath = `/accounts/persons/{accountId}/memberships`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets roles in organisation {organisationId} the account {accountId} has. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canRead   accounts/persons, canRead (in {organisationId})
         * @summary getPersonAccountRoleAssignmentsInOrganisation - Get roles in organisation {organisationId} the account {accountId} has
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccountRoleAssignmentsInOrganisation: async (accountId, organisationId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getPersonAccountRoleAssignmentsInOrganisation', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getPersonAccountRoleAssignmentsInOrganisation', 'organisationId', organisationId);
            const localVarPath = `/accounts/persons/{accountId}/memberships/{organisationId}/role-assignments`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * the requesting account is accountId    **Note: isLocked can be modified, i.e. set to true by the account himself**
         * @summary updatePersonAccountMembership - Updates membership in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {AccountMembershipUpdate} accountMembershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonAccountMembership: async (accountId, organisationId, accountMembershipUpdate, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('updatePersonAccountMembership', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('updatePersonAccountMembership', 'organisationId', organisationId);
            // verify required parameter 'accountMembershipUpdate' is not null or undefined
            common_1.assertParamExists('updatePersonAccountMembership', 'accountMembershipUpdate', accountMembershipUpdate);
            const localVarPath = `/accounts/persons/{accountId}/memberships/{organisationId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(accountMembershipUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates membership lock state of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * account_memberships, canUpdate (in organsationId)    ** The owner account of an organisation cannot be locked**
         * @summary updatePersonAccountMembershipLockState - Updates membership lock state in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {AccountMembershipLockStateUpdate} accountMembershipLockStateUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonAccountMembershipLockState: async (accountId, organisationId, accountMembershipLockStateUpdate, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('updatePersonAccountMembershipLockState', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('updatePersonAccountMembershipLockState', 'organisationId', organisationId);
            // verify required parameter 'accountMembershipLockStateUpdate' is not null or undefined
            common_1.assertParamExists('updatePersonAccountMembershipLockState', 'accountMembershipLockStateUpdate', accountMembershipLockStateUpdate);
            const localVarPath = `/accounts/persons/{accountId}/memberships/{organisationId}/lock-state`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(accountMembershipLockStateUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsPersonsMembershipsApi - functional programming interface
 * @export
 */
exports.AccountsPersonsMembershipsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountsPersonsMembershipsApiAxiosParamCreator(configuration);
    return {
        /**
         * Add access rights for account {accountId} in organisation {organisationId}. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights and cannot be altered. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canUpdate   accounts/persons, canUpdate (in {organisationId})
         * @summary addPersonAccountRoleAssignmentInOrganisation - Add access rights for account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Creates a membership of account {accountId}. The requesting account must have sufficient rights to perform this operation:   account_memberships, canCreate
         * @summary createPersonAccountMembership - Create a membership of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {AccountMembershipCreate} accountMembershipCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPersonAccountMembership(accountId, accountMembershipCreate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPersonAccountMembership(accountId, accountMembershipCreate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deletes membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * account_memberships, canDelete (in organisationId)
         * @summary deletePersonAccountMembership - Delete membership in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePersonAccountMembership(accountId, organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePersonAccountMembership(accountId, organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deletes access rights of account {accountId} in organisation {organisationId}. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights and cannot be altered. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canUpdate   accounts/persons, canUpdate (in {organisationId})
         * @summary deletePersonAccountRoleAssignmentInOrganisation - Delete access rights of account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets organisations the account {accountId} is member of. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canRead    or    * requesting account is {accountId}
         * @summary getPersonAccountMemberships - Get organisations the account {accountId} is member of
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonAccountMemberships(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonAccountMemberships(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets roles in organisation {organisationId} the account {accountId} has. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canRead   accounts/persons, canRead (in {organisationId})
         * @summary getPersonAccountRoleAssignmentsInOrganisation - Get roles in organisation {organisationId} the account {accountId} has
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonAccountRoleAssignmentsInOrganisation(accountId, organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonAccountRoleAssignmentsInOrganisation(accountId, organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Updates membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * the requesting account is accountId    **Note: isLocked can be modified, i.e. set to true by the account himself**
         * @summary updatePersonAccountMembership - Updates membership in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {AccountMembershipUpdate} accountMembershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonAccountMembership(accountId, organisationId, accountMembershipUpdate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonAccountMembership(accountId, organisationId, accountMembershipUpdate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Updates membership lock state of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * account_memberships, canUpdate (in organsationId)    ** The owner account of an organisation cannot be locked**
         * @summary updatePersonAccountMembershipLockState - Updates membership lock state in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {AccountMembershipLockStateUpdate} accountMembershipLockStateUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonAccountMembershipLockState(accountId, organisationId, accountMembershipLockStateUpdate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonAccountMembershipLockState(accountId, organisationId, accountMembershipLockStateUpdate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsPersonsMembershipsApi - factory interface
 * @export
 */
exports.AccountsPersonsMembershipsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountsPersonsMembershipsApiFp(configuration);
    return {
        /**
         * Add access rights for account {accountId} in organisation {organisationId}. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights and cannot be altered. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canUpdate   accounts/persons, canUpdate (in {organisationId})
         * @summary addPersonAccountRoleAssignmentInOrganisation - Add access rights for account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
            return localVarFp.addPersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a membership of account {accountId}. The requesting account must have sufficient rights to perform this operation:   account_memberships, canCreate
         * @summary createPersonAccountMembership - Create a membership of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {AccountMembershipCreate} accountMembershipCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonAccountMembership(accountId, accountMembershipCreate, options) {
            return localVarFp.createPersonAccountMembership(accountId, accountMembershipCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * account_memberships, canDelete (in organisationId)
         * @summary deletePersonAccountMembership - Delete membership in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonAccountMembership(accountId, organisationId, options) {
            return localVarFp.deletePersonAccountMembership(accountId, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes access rights of account {accountId} in organisation {organisationId}. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights and cannot be altered. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canUpdate   accounts/persons, canUpdate (in {organisationId})
         * @summary deletePersonAccountRoleAssignmentInOrganisation - Delete access rights of account {accountId} in organisation {organisationId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
            return localVarFp.deletePersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets organisations the account {accountId} is member of. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canRead    or    * requesting account is {accountId}
         * @summary getPersonAccountMemberships - Get organisations the account {accountId} is member of
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccountMemberships(accountId, options) {
            return localVarFp.getPersonAccountMemberships(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets roles in organisation {organisationId} the account {accountId} has. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canRead   accounts/persons, canRead (in {organisationId})
         * @summary getPersonAccountRoleAssignmentsInOrganisation - Get roles in organisation {organisationId} the account {accountId} has
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonAccountRoleAssignmentsInOrganisation(accountId, organisationId, options) {
            return localVarFp.getPersonAccountRoleAssignmentsInOrganisation(accountId, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * the requesting account is accountId    **Note: isLocked can be modified, i.e. set to true by the account himself**
         * @summary updatePersonAccountMembership - Updates membership in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {AccountMembershipUpdate} accountMembershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonAccountMembership(accountId, organisationId, accountMembershipUpdate, options) {
            return localVarFp.updatePersonAccountMembership(accountId, organisationId, accountMembershipUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates membership lock state of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * account_memberships, canUpdate (in organsationId)    ** The owner account of an organisation cannot be locked**
         * @summary updatePersonAccountMembershipLockState - Updates membership lock state in organisation {organisationId} of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {AccountMembershipLockStateUpdate} accountMembershipLockStateUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonAccountMembershipLockState(accountId, organisationId, accountMembershipLockStateUpdate, options) {
            return localVarFp.updatePersonAccountMembershipLockState(accountId, organisationId, accountMembershipLockStateUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsPersonsMembershipsApi - object-oriented interface
 * @export
 * @class AccountsPersonsMembershipsApi
 * @extends {BaseAPI}
 */
class AccountsPersonsMembershipsApi extends base_1.BaseAPI {
    /**
     * Add access rights for account {accountId} in organisation {organisationId}. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights and cannot be altered. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canUpdate   accounts/persons, canUpdate (in {organisationId})
     * @summary addPersonAccountRoleAssignmentInOrganisation - Add access rights for account {accountId} in organisation {organisationId}
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {RoleResourceCombination} roleResourceCombination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsMembershipsApi
     */
    addPersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
        return exports.AccountsPersonsMembershipsApiFp(this.configuration).addPersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a membership of account {accountId}. The requesting account must have sufficient rights to perform this operation:   account_memberships, canCreate
     * @summary createPersonAccountMembership - Create a membership of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {AccountMembershipCreate} accountMembershipCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsMembershipsApi
     */
    createPersonAccountMembership(accountId, accountMembershipCreate, options) {
        return exports.AccountsPersonsMembershipsApiFp(this.configuration).createPersonAccountMembership(accountId, accountMembershipCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * account_memberships, canDelete (in organisationId)
     * @summary deletePersonAccountMembership - Delete membership in organisation {organisationId} of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsMembershipsApi
     */
    deletePersonAccountMembership(accountId, organisationId, options) {
        return exports.AccountsPersonsMembershipsApiFp(this.configuration).deletePersonAccountMembership(accountId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes access rights of account {accountId} in organisation {organisationId}. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights and cannot be altered. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canUpdate   accounts/persons, canUpdate (in {organisationId})
     * @summary deletePersonAccountRoleAssignmentInOrganisation - Delete access rights of account {accountId} in organisation {organisationId}
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {RoleResourceCombination} roleResourceCombination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsMembershipsApi
     */
    deletePersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options) {
        return exports.AccountsPersonsMembershipsApiFp(this.configuration).deletePersonAccountRoleAssignmentInOrganisation(accountId, organisationId, roleResourceCombination, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets organisations the account {accountId} is member of. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canRead    or    * requesting account is {accountId}
     * @summary getPersonAccountMemberships - Get organisations the account {accountId} is member of
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsMembershipsApi
     */
    getPersonAccountMemberships(accountId, options) {
        return exports.AccountsPersonsMembershipsApiFp(this.configuration).getPersonAccountMemberships(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets roles in organisation {organisationId} the account {accountId} has. In case {accountId} is the owner of {organisationId} these rights are identical with the organisation access rights. The requesting account must have sufficient rights to perform this operation:   accounts/persons/all, canRead   accounts/persons, canRead (in {organisationId})
     * @summary getPersonAccountRoleAssignmentsInOrganisation - Get roles in organisation {organisationId} the account {accountId} has
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsMembershipsApi
     */
    getPersonAccountRoleAssignmentsInOrganisation(accountId, organisationId, options) {
        return exports.AccountsPersonsMembershipsApiFp(this.configuration).getPersonAccountRoleAssignmentsInOrganisation(accountId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates membership of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * the requesting account is accountId    **Note: isLocked can be modified, i.e. set to true by the account himself**
     * @summary updatePersonAccountMembership - Updates membership in organisation {organisationId} of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {AccountMembershipUpdate} accountMembershipUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsMembershipsApi
     */
    updatePersonAccountMembership(accountId, organisationId, accountMembershipUpdate, options) {
        return exports.AccountsPersonsMembershipsApiFp(this.configuration).updatePersonAccountMembership(accountId, organisationId, accountMembershipUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates membership lock state of account {accountId} in organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:    * accounts/persons/all, canUpdate    or    * account_memberships, canUpdate (in organsationId)    ** The owner account of an organisation cannot be locked**
     * @summary updatePersonAccountMembershipLockState - Updates membership lock state in organisation {organisationId} of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {AccountMembershipLockStateUpdate} accountMembershipLockStateUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsPersonsMembershipsApi
     */
    updatePersonAccountMembershipLockState(accountId, organisationId, accountMembershipLockStateUpdate, options) {
        return exports.AccountsPersonsMembershipsApiFp(this.configuration).updatePersonAccountMembershipLockState(accountId, organisationId, accountMembershipLockStateUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountsPersonsMembershipsApi = AccountsPersonsMembershipsApi;
/**
 * AccountsSettingsApi - axios parameter creator
 * @export
 */
exports.AccountsSettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets settings of requesting account. The requesting account must have sufficient rights to perform this operation:   any account can retrieve its own settings with a valid access token
         * @summary getAccountSettings - Get settings of requesting account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSettings: async (options = {}) => {
            const localVarPath = `/accounts/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates settings of requesting account. The requesting account must have sufficient rights to perform this operation:   any account can update its own settings with a valid access token
         * @summary updateAccountSettings - Update settings of requesting account
         * @param {object} body New settings of account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountSettings: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            common_1.assertParamExists('updateAccountSettings', 'body', body);
            const localVarPath = `/accounts/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsSettingsApi - functional programming interface
 * @export
 */
exports.AccountsSettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountsSettingsApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets settings of requesting account. The requesting account must have sufficient rights to perform this operation:   any account can retrieve its own settings with a valid access token
         * @summary getAccountSettings - Get settings of requesting account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountSettings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountSettings(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Updates settings of requesting account. The requesting account must have sufficient rights to perform this operation:   any account can update its own settings with a valid access token
         * @summary updateAccountSettings - Update settings of requesting account
         * @param {object} body New settings of account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountSettings(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountSettings(body, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsSettingsApi - factory interface
 * @export
 */
exports.AccountsSettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountsSettingsApiFp(configuration);
    return {
        /**
         * Gets settings of requesting account. The requesting account must have sufficient rights to perform this operation:   any account can retrieve its own settings with a valid access token
         * @summary getAccountSettings - Get settings of requesting account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSettings(options) {
            return localVarFp.getAccountSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * Updates settings of requesting account. The requesting account must have sufficient rights to perform this operation:   any account can update its own settings with a valid access token
         * @summary updateAccountSettings - Update settings of requesting account
         * @param {object} body New settings of account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountSettings(body, options) {
            return localVarFp.updateAccountSettings(body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsSettingsApi - object-oriented interface
 * @export
 * @class AccountsSettingsApi
 * @extends {BaseAPI}
 */
class AccountsSettingsApi extends base_1.BaseAPI {
    /**
     * Gets settings of requesting account. The requesting account must have sufficient rights to perform this operation:   any account can retrieve its own settings with a valid access token
     * @summary getAccountSettings - Get settings of requesting account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsSettingsApi
     */
    getAccountSettings(options) {
        return exports.AccountsSettingsApiFp(this.configuration).getAccountSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates settings of requesting account. The requesting account must have sufficient rights to perform this operation:   any account can update its own settings with a valid access token
     * @summary updateAccountSettings - Update settings of requesting account
     * @param {object} body New settings of account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsSettingsApi
     */
    updateAccountSettings(body, options) {
        return exports.AccountsSettingsApiFp(this.configuration).updateAccountSettings(body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountsSettingsApi = AccountsSettingsApi;
/**
 * AuthAccountAccessRightsApi - axios parameter creator
 * @export
 */
exports.AuthAccountAccessRightsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources. The requesting account must have sufficient rights to perform this operation:   * accounts/all, canRead   or   * accounts, canRead (in organisationId)   or   * requesting account is accountId
         * @summary getAccountAccessRights - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessRights: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getAccountAccessRights', 'accountId', accountId);
            const localVarPath = `/accounts/{accountId}/access-rights`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources.
         * @summary getAccountAccessRights_Unsecured - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessRightsUnsecured: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getAccountAccessRightsUnsecured', 'accountId', accountId);
            const localVarPath = `/internal/accounts/{accountId}/access-rights`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthAccountAccessRightsApi - functional programming interface
 * @export
 */
exports.AuthAccountAccessRightsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthAccountAccessRightsApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources. The requesting account must have sufficient rights to perform this operation:   * accounts/all, canRead   or   * accounts, canRead (in organisationId)   or   * requesting account is accountId
         * @summary getAccountAccessRights - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountAccessRights(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountAccessRights(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources.
         * @summary getAccountAccessRights_Unsecured - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountAccessRightsUnsecured(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountAccessRightsUnsecured(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AuthAccountAccessRightsApi - factory interface
 * @export
 */
exports.AuthAccountAccessRightsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthAccountAccessRightsApiFp(configuration);
    return {
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources. The requesting account must have sufficient rights to perform this operation:   * accounts/all, canRead   or   * accounts, canRead (in organisationId)   or   * requesting account is accountId
         * @summary getAccountAccessRights - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessRights(accountId, options) {
            return localVarFp.getAccountAccessRights(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources.
         * @summary getAccountAccessRights_Unsecured - Get detailed access rights of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAccessRightsUnsecured(accountId, options) {
            return localVarFp.getAccountAccessRightsUnsecured(accountId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthAccountAccessRightsApi - object-oriented interface
 * @export
 * @class AuthAccountAccessRightsApi
 * @extends {BaseAPI}
 */
class AuthAccountAccessRightsApi extends base_1.BaseAPI {
    /**
     * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources. The requesting account must have sufficient rights to perform this operation:   * accounts/all, canRead   or   * accounts, canRead (in organisationId)   or   * requesting account is accountId
     * @summary getAccountAccessRights - Get detailed access rights of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthAccountAccessRightsApi
     */
    getAccountAccessRights(accountId, options) {
        return exports.AuthAccountAccessRightsApiFp(this.configuration).getAccountAccessRights(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the detailed access rights of account {accountId}. The access rights are ordered by the organisation IDs the account is associated. The access rights are detailed for all rights objects and resources. The associated roles are not enclosed here. The access rights may vary across the organisations. This must be retrieved by other NRail services to know the rights of an account requesting their resources.
     * @summary getAccountAccessRights_Unsecured - Get detailed access rights of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthAccountAccessRightsApi
     */
    getAccountAccessRightsUnsecured(accountId, options) {
        return exports.AuthAccountAccessRightsApiFp(this.configuration).getAccountAccessRightsUnsecured(accountId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthAccountAccessRightsApi = AuthAccountAccessRightsApi;
/**
 * AuthAccountCertificatesApi - axios parameter creator
 * @export
 */
exports.AuthAccountCertificatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets PKI certificate of account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/all, canRead   or   requesting account is {accountId}
         * @summary getAccountCertificate - Get PKI certificate of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCertificate: async (accountId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getAccountCertificate', 'accountId', accountId);
            const localVarPath = `/accounts/{accountId}/certificate`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthAccountCertificatesApi - functional programming interface
 * @export
 */
exports.AuthAccountCertificatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthAccountCertificatesApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets PKI certificate of account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/all, canRead   or   requesting account is {accountId}
         * @summary getAccountCertificate - Get PKI certificate of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountCertificate(accountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountCertificate(accountId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AuthAccountCertificatesApi - factory interface
 * @export
 */
exports.AuthAccountCertificatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthAccountCertificatesApiFp(configuration);
    return {
        /**
         * Gets PKI certificate of account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/all, canRead   or   requesting account is {accountId}
         * @summary getAccountCertificate - Get PKI certificate of account {accountId}
         * @param {string} accountId The ID of the account resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCertificate(accountId, options) {
            return localVarFp.getAccountCertificate(accountId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthAccountCertificatesApi - object-oriented interface
 * @export
 * @class AuthAccountCertificatesApi
 * @extends {BaseAPI}
 */
class AuthAccountCertificatesApi extends base_1.BaseAPI {
    /**
     * Gets PKI certificate of account {accountId}. The requesting account must have sufficient rights to perform this operation:   accounts/all, canRead   or   requesting account is {accountId}
     * @summary getAccountCertificate - Get PKI certificate of account {accountId}
     * @param {string} accountId The ID of the account resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthAccountCertificatesApi
     */
    getAccountCertificate(accountId, options) {
        return exports.AuthAccountCertificatesApiFp(this.configuration).getAccountCertificate(accountId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthAccountCertificatesApi = AuthAccountCertificatesApi;
/**
 * AuthBasicApi - axios parameter creator
 * @export
 */
exports.AuthBasicApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates a basic access token from a refresh token.  Access tokens have to be used for accessing NRail services or routes of this service.  The tokens contain among other data:    * The account ID and name   * The IDs of the organisations the account is associated with  The access token is short lived while the refresh token has a much longer life-span.  The access token has to be refreshed by using the refresh token periodically.
         * @summary createAccessToken - Create basic access token from a refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken: async (options = {}) => {
            const localVarPath = `/auth/access-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication RefreshTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a basic JWT refresh token.  It has to be used to generate access tokens for accessing NRail services or routes of this service.  The token contains among other data:    * The account ID and name   * The IDs of the organisations the account is associated with  A access token is short live while the refresh token has a much longer life-span.  A access token has to be refreshed by using the refresh token periodically.  **TODO - Consider returning a first access token with this response.**
         * @summary createRefreshToken - Create basic refresh token based on account credentials
         * @param {RefreshTokenCredentials} refreshTokenCredentials The credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefreshToken: async (refreshTokenCredentials, options = {}) => {
            // verify required parameter 'refreshTokenCredentials' is not null or undefined
            common_1.assertParamExists('createRefreshToken', 'refreshTokenCredentials', refreshTokenCredentials);
            const localVarPath = `/auth/refresh-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(refreshTokenCredentials, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a revocation for the provided refresh token. This should be called during a frontend logout process. After that this refresh token can no longer be used to aquire new access tokens and access tokens generated with it can no longer be used to access resources of NRail services.
         * @summary createRefreshTokenRevocation - Create a refresh token revocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefreshTokenRevocation: async (options = {}) => {
            const localVarPath = `/auth/refresh-tokens/revocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication RefreshTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthBasicApi - functional programming interface
 * @export
 */
exports.AuthBasicApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthBasicApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a basic access token from a refresh token.  Access tokens have to be used for accessing NRail services or routes of this service.  The tokens contain among other data:    * The account ID and name   * The IDs of the organisations the account is associated with  The access token is short lived while the refresh token has a much longer life-span.  The access token has to be refreshed by using the refresh token periodically.
         * @summary createAccessToken - Create basic access token from a refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccessToken(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccessToken(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Creates a basic JWT refresh token.  It has to be used to generate access tokens for accessing NRail services or routes of this service.  The token contains among other data:    * The account ID and name   * The IDs of the organisations the account is associated with  A access token is short live while the refresh token has a much longer life-span.  A access token has to be refreshed by using the refresh token periodically.  **TODO - Consider returning a first access token with this response.**
         * @summary createRefreshToken - Create basic refresh token based on account credentials
         * @param {RefreshTokenCredentials} refreshTokenCredentials The credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRefreshToken(refreshTokenCredentials, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRefreshToken(refreshTokenCredentials, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Creates a revocation for the provided refresh token. This should be called during a frontend logout process. After that this refresh token can no longer be used to aquire new access tokens and access tokens generated with it can no longer be used to access resources of NRail services.
         * @summary createRefreshTokenRevocation - Create a refresh token revocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRefreshTokenRevocation(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRefreshTokenRevocation(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AuthBasicApi - factory interface
 * @export
 */
exports.AuthBasicApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthBasicApiFp(configuration);
    return {
        /**
         * Creates a basic access token from a refresh token.  Access tokens have to be used for accessing NRail services or routes of this service.  The tokens contain among other data:    * The account ID and name   * The IDs of the organisations the account is associated with  The access token is short lived while the refresh token has a much longer life-span.  The access token has to be refreshed by using the refresh token periodically.
         * @summary createAccessToken - Create basic access token from a refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken(options) {
            return localVarFp.createAccessToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a basic JWT refresh token.  It has to be used to generate access tokens for accessing NRail services or routes of this service.  The token contains among other data:    * The account ID and name   * The IDs of the organisations the account is associated with  A access token is short live while the refresh token has a much longer life-span.  A access token has to be refreshed by using the refresh token periodically.  **TODO - Consider returning a first access token with this response.**
         * @summary createRefreshToken - Create basic refresh token based on account credentials
         * @param {RefreshTokenCredentials} refreshTokenCredentials The credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefreshToken(refreshTokenCredentials, options) {
            return localVarFp.createRefreshToken(refreshTokenCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a revocation for the provided refresh token. This should be called during a frontend logout process. After that this refresh token can no longer be used to aquire new access tokens and access tokens generated with it can no longer be used to access resources of NRail services.
         * @summary createRefreshTokenRevocation - Create a refresh token revocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefreshTokenRevocation(options) {
            return localVarFp.createRefreshTokenRevocation(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthBasicApi - object-oriented interface
 * @export
 * @class AuthBasicApi
 * @extends {BaseAPI}
 */
class AuthBasicApi extends base_1.BaseAPI {
    /**
     * Creates a basic access token from a refresh token.  Access tokens have to be used for accessing NRail services or routes of this service.  The tokens contain among other data:    * The account ID and name   * The IDs of the organisations the account is associated with  The access token is short lived while the refresh token has a much longer life-span.  The access token has to be refreshed by using the refresh token periodically.
     * @summary createAccessToken - Create basic access token from a refresh token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthBasicApi
     */
    createAccessToken(options) {
        return exports.AuthBasicApiFp(this.configuration).createAccessToken(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a basic JWT refresh token.  It has to be used to generate access tokens for accessing NRail services or routes of this service.  The token contains among other data:    * The account ID and name   * The IDs of the organisations the account is associated with  A access token is short live while the refresh token has a much longer life-span.  A access token has to be refreshed by using the refresh token periodically.  **TODO - Consider returning a first access token with this response.**
     * @summary createRefreshToken - Create basic refresh token based on account credentials
     * @param {RefreshTokenCredentials} refreshTokenCredentials The credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthBasicApi
     */
    createRefreshToken(refreshTokenCredentials, options) {
        return exports.AuthBasicApiFp(this.configuration).createRefreshToken(refreshTokenCredentials, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a revocation for the provided refresh token. This should be called during a frontend logout process. After that this refresh token can no longer be used to aquire new access tokens and access tokens generated with it can no longer be used to access resources of NRail services.
     * @summary createRefreshTokenRevocation - Create a refresh token revocation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthBasicApi
     */
    createRefreshTokenRevocation(options) {
        return exports.AuthBasicApiFp(this.configuration).createRefreshTokenRevocation(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthBasicApi = AuthBasicApi;
/**
 * AuthCertificatesApi - axios parameter creator
 * @export
 */
exports.AuthCertificatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets the currently active certificates that must be used to verify access tokens. The property key is the key ID (kid). This is contained in generated access keys and can be used to look up the used certificate.  This route is unprotected.
         * @summary getCertificates - Get certificates that must be used for verifying access tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificates: async (options = {}) => {
            const localVarPath = `/auth/certificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthCertificatesApi - functional programming interface
 * @export
 */
exports.AuthCertificatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthCertificatesApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets the currently active certificates that must be used to verify access tokens. The property key is the key ID (kid). This is contained in generated access keys and can be used to look up the used certificate.  This route is unprotected.
         * @summary getCertificates - Get certificates that must be used for verifying access tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCertificates(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCertificates(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AuthCertificatesApi - factory interface
 * @export
 */
exports.AuthCertificatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthCertificatesApiFp(configuration);
    return {
        /**
         * Gets the currently active certificates that must be used to verify access tokens. The property key is the key ID (kid). This is contained in generated access keys and can be used to look up the used certificate.  This route is unprotected.
         * @summary getCertificates - Get certificates that must be used for verifying access tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificates(options) {
            return localVarFp.getCertificates(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthCertificatesApi - object-oriented interface
 * @export
 * @class AuthCertificatesApi
 * @extends {BaseAPI}
 */
class AuthCertificatesApi extends base_1.BaseAPI {
    /**
     * Gets the currently active certificates that must be used to verify access tokens. The property key is the key ID (kid). This is contained in generated access keys and can be used to look up the used certificate.  This route is unprotected.
     * @summary getCertificates - Get certificates that must be used for verifying access tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthCertificatesApi
     */
    getCertificates(options) {
        return exports.AuthCertificatesApiFp(this.configuration).getCertificates(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthCertificatesApi = AuthCertificatesApi;
/**
 * AuthOtpApi - axios parameter creator
 * @export
 */
exports.AuthOtpApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Generates a temporary secret for time-based one-time password (OTP) authentification. This has to be verified and activated before OTP can be used to generate access tokens. The secret is stored in the account. It is returned in the response along with an otpauth displaying a PNG to be scanned by Google Authenticator or other apps.
         * @summary createOtpSecret - Generate OTP secret for the requesting account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOtpSecret: async (options = {}) => {
            const localVarPath = `/auth/otp/secret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates an refresh token based on a recovery code provided via /auth/otp/activation. The used recovery code cannot be used afterwards.
         * @summary createRecoveryRefreshToken - Generate recovery refresh token based on OTP recovery code
         * @param {OtpRecoveryAuthentificationCredentials} otpRecoveryAuthentificationCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecoveryRefreshToken: async (otpRecoveryAuthentificationCredentials, options = {}) => {
            // verify required parameter 'otpRecoveryAuthentificationCredentials' is not null or undefined
            common_1.assertParamExists('createRecoveryRefreshToken', 'otpRecoveryAuthentificationCredentials', otpRecoveryAuthentificationCredentials);
            const localVarPath = `/auth/otp/recovery-refresh-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication IncompleteOtpAccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(otpRecoveryAuthentificationCredentials, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a refresh token with OTP security. Credentials are: (1) An basic refresh token marked as not OTP-authenticated and (2) an OTP token. The returned JWT refresh token is marked as OTP-authenticated. This can be used to generate access tokens with OTP security that can used to access other resources. Time-based OTP for the requesting account must be activated and the account must have a verified and activated OTP secret. The token contains among other data   * The account ID and name   * The IDs of the organisations the account is associated with
         * @summary createRefreshTokenWithOtp Generate refresh token with OTP security for the requesting account
         * @param {OtpAuthentificationCredentials} otpAuthentificationCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefreshTokenWithOtp: async (otpAuthentificationCredentials, options = {}) => {
            // verify required parameter 'otpAuthentificationCredentials' is not null or undefined
            common_1.assertParamExists('createRefreshTokenWithOtp', 'otpAuthentificationCredentials', otpAuthentificationCredentials);
            const localVarPath = `/auth/otp/refresh-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication IncompleteOtpRefreshTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(otpAuthentificationCredentials, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivates the OTP secret generated via /auth/otp/secret. The route is protected by an access token.
         * @summary deactivateOtpSecret - Deactivates OTP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateOtpSecret: async (options = {}) => {
            const localVarPath = `/auth/otp/activation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies and activates a temporary OTP secret generated via /auth/otp/secret. The route is protected by a basic access token. A OTP token must be provided in the body. Based on these credentials the temporary secret of the account is made permanent.
         * @summary verifyAndActivateOtpSecret - Verify and activate OTP secret for the requesting account. Activates OTP
         * @param {OtpAuthentificationCredentials} otpAuthentificationCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAndActivateOtpSecret: async (otpAuthentificationCredentials, options = {}) => {
            // verify required parameter 'otpAuthentificationCredentials' is not null or undefined
            common_1.assertParamExists('verifyAndActivateOtpSecret', 'otpAuthentificationCredentials', otpAuthentificationCredentials);
            const localVarPath = `/auth/otp/activation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(otpAuthentificationCredentials, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthOtpApi - functional programming interface
 * @export
 */
exports.AuthOtpApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthOtpApiAxiosParamCreator(configuration);
    return {
        /**
         * Generates a temporary secret for time-based one-time password (OTP) authentification. This has to be verified and activated before OTP can be used to generate access tokens. The secret is stored in the account. It is returned in the response along with an otpauth displaying a PNG to be scanned by Google Authenticator or other apps.
         * @summary createOtpSecret - Generate OTP secret for the requesting account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOtpSecret(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOtpSecret(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Generates an refresh token based on a recovery code provided via /auth/otp/activation. The used recovery code cannot be used afterwards.
         * @summary createRecoveryRefreshToken - Generate recovery refresh token based on OTP recovery code
         * @param {OtpRecoveryAuthentificationCredentials} otpRecoveryAuthentificationCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRecoveryRefreshToken(otpRecoveryAuthentificationCredentials, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRecoveryRefreshToken(otpRecoveryAuthentificationCredentials, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Generates a refresh token with OTP security. Credentials are: (1) An basic refresh token marked as not OTP-authenticated and (2) an OTP token. The returned JWT refresh token is marked as OTP-authenticated. This can be used to generate access tokens with OTP security that can used to access other resources. Time-based OTP for the requesting account must be activated and the account must have a verified and activated OTP secret. The token contains among other data   * The account ID and name   * The IDs of the organisations the account is associated with
         * @summary createRefreshTokenWithOtp Generate refresh token with OTP security for the requesting account
         * @param {OtpAuthentificationCredentials} otpAuthentificationCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRefreshTokenWithOtp(otpAuthentificationCredentials, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRefreshTokenWithOtp(otpAuthentificationCredentials, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deactivates the OTP secret generated via /auth/otp/secret. The route is protected by an access token.
         * @summary deactivateOtpSecret - Deactivates OTP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateOtpSecret(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateOtpSecret(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Verifies and activates a temporary OTP secret generated via /auth/otp/secret. The route is protected by a basic access token. A OTP token must be provided in the body. Based on these credentials the temporary secret of the account is made permanent.
         * @summary verifyAndActivateOtpSecret - Verify and activate OTP secret for the requesting account. Activates OTP
         * @param {OtpAuthentificationCredentials} otpAuthentificationCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyAndActivateOtpSecret(otpAuthentificationCredentials, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyAndActivateOtpSecret(otpAuthentificationCredentials, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AuthOtpApi - factory interface
 * @export
 */
exports.AuthOtpApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthOtpApiFp(configuration);
    return {
        /**
         * Generates a temporary secret for time-based one-time password (OTP) authentification. This has to be verified and activated before OTP can be used to generate access tokens. The secret is stored in the account. It is returned in the response along with an otpauth displaying a PNG to be scanned by Google Authenticator or other apps.
         * @summary createOtpSecret - Generate OTP secret for the requesting account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOtpSecret(options) {
            return localVarFp.createOtpSecret(options).then((request) => request(axios, basePath));
        },
        /**
         * Generates an refresh token based on a recovery code provided via /auth/otp/activation. The used recovery code cannot be used afterwards.
         * @summary createRecoveryRefreshToken - Generate recovery refresh token based on OTP recovery code
         * @param {OtpRecoveryAuthentificationCredentials} otpRecoveryAuthentificationCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecoveryRefreshToken(otpRecoveryAuthentificationCredentials, options) {
            return localVarFp.createRecoveryRefreshToken(otpRecoveryAuthentificationCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a refresh token with OTP security. Credentials are: (1) An basic refresh token marked as not OTP-authenticated and (2) an OTP token. The returned JWT refresh token is marked as OTP-authenticated. This can be used to generate access tokens with OTP security that can used to access other resources. Time-based OTP for the requesting account must be activated and the account must have a verified and activated OTP secret. The token contains among other data   * The account ID and name   * The IDs of the organisations the account is associated with
         * @summary createRefreshTokenWithOtp Generate refresh token with OTP security for the requesting account
         * @param {OtpAuthentificationCredentials} otpAuthentificationCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefreshTokenWithOtp(otpAuthentificationCredentials, options) {
            return localVarFp.createRefreshTokenWithOtp(otpAuthentificationCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivates the OTP secret generated via /auth/otp/secret. The route is protected by an access token.
         * @summary deactivateOtpSecret - Deactivates OTP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateOtpSecret(options) {
            return localVarFp.deactivateOtpSecret(options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies and activates a temporary OTP secret generated via /auth/otp/secret. The route is protected by a basic access token. A OTP token must be provided in the body. Based on these credentials the temporary secret of the account is made permanent.
         * @summary verifyAndActivateOtpSecret - Verify and activate OTP secret for the requesting account. Activates OTP
         * @param {OtpAuthentificationCredentials} otpAuthentificationCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAndActivateOtpSecret(otpAuthentificationCredentials, options) {
            return localVarFp.verifyAndActivateOtpSecret(otpAuthentificationCredentials, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthOtpApi - object-oriented interface
 * @export
 * @class AuthOtpApi
 * @extends {BaseAPI}
 */
class AuthOtpApi extends base_1.BaseAPI {
    /**
     * Generates a temporary secret for time-based one-time password (OTP) authentification. This has to be verified and activated before OTP can be used to generate access tokens. The secret is stored in the account. It is returned in the response along with an otpauth displaying a PNG to be scanned by Google Authenticator or other apps.
     * @summary createOtpSecret - Generate OTP secret for the requesting account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthOtpApi
     */
    createOtpSecret(options) {
        return exports.AuthOtpApiFp(this.configuration).createOtpSecret(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Generates an refresh token based on a recovery code provided via /auth/otp/activation. The used recovery code cannot be used afterwards.
     * @summary createRecoveryRefreshToken - Generate recovery refresh token based on OTP recovery code
     * @param {OtpRecoveryAuthentificationCredentials} otpRecoveryAuthentificationCredentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthOtpApi
     */
    createRecoveryRefreshToken(otpRecoveryAuthentificationCredentials, options) {
        return exports.AuthOtpApiFp(this.configuration).createRecoveryRefreshToken(otpRecoveryAuthentificationCredentials, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Generates a refresh token with OTP security. Credentials are: (1) An basic refresh token marked as not OTP-authenticated and (2) an OTP token. The returned JWT refresh token is marked as OTP-authenticated. This can be used to generate access tokens with OTP security that can used to access other resources. Time-based OTP for the requesting account must be activated and the account must have a verified and activated OTP secret. The token contains among other data   * The account ID and name   * The IDs of the organisations the account is associated with
     * @summary createRefreshTokenWithOtp Generate refresh token with OTP security for the requesting account
     * @param {OtpAuthentificationCredentials} otpAuthentificationCredentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthOtpApi
     */
    createRefreshTokenWithOtp(otpAuthentificationCredentials, options) {
        return exports.AuthOtpApiFp(this.configuration).createRefreshTokenWithOtp(otpAuthentificationCredentials, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deactivates the OTP secret generated via /auth/otp/secret. The route is protected by an access token.
     * @summary deactivateOtpSecret - Deactivates OTP
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthOtpApi
     */
    deactivateOtpSecret(options) {
        return exports.AuthOtpApiFp(this.configuration).deactivateOtpSecret(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Verifies and activates a temporary OTP secret generated via /auth/otp/secret. The route is protected by a basic access token. A OTP token must be provided in the body. Based on these credentials the temporary secret of the account is made permanent.
     * @summary verifyAndActivateOtpSecret - Verify and activate OTP secret for the requesting account. Activates OTP
     * @param {OtpAuthentificationCredentials} otpAuthentificationCredentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthOtpApi
     */
    verifyAndActivateOtpSecret(otpAuthentificationCredentials, options) {
        return exports.AuthOtpApiFp(this.configuration).verifyAndActivateOtpSecret(otpAuthentificationCredentials, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthOtpApi = AuthOtpApi;
/**
 * AuthPasskeyApi - axios parameter creator
 * @export
 */
exports.AuthPasskeyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Resets the passkey of the account specified in the passkey reset authentification token. A new passkey and an passkey reset authentification token must be provided. This authentification token can be requested via /accounts/{accountId}/passkey-reset-request.
         * @summary createPasskeyReset - Reset the passkey of an account after receiving an reset authentification token
         * @param {ResetPasskey} resetPasskey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasskeyReset: async (resetPasskey, options = {}) => {
            // verify required parameter 'resetPasskey' is not null or undefined
            common_1.assertParamExists('createPasskeyReset', 'resetPasskey', resetPasskey);
            const localVarPath = `/auth/passkey/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(resetPasskey, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a passkey reset request and sends a mail to the email address of the account specified in the body containing a passkey reset token that has to be provided when resetting the passkey. The passkey reset token has an expiration time.
         * @summary createPasskeyResetRequest - Create passkey reset request for a person account. Send an email to the account\'s email address 🚧 TODO - Require OTP code?!
         * @param {PasskeyResetRequest} passkeyResetRequest The passkey reset request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasskeyResetRequest: async (passkeyResetRequest, options = {}) => {
            // verify required parameter 'passkeyResetRequest' is not null or undefined
            common_1.assertParamExists('createPasskeyResetRequest', 'passkeyResetRequest', passkeyResetRequest);
            const localVarPath = `/auth/passkey/reset-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(passkeyResetRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the passkey of the requesting account. This method is protected through an access token that has to be provided.
         * @summary updatePasskey - Update the passkey of the requesting account
         * @param {PasskeyChangeSettings} passkeyChangeSettings Old and new passkey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasskey: async (passkeyChangeSettings, options = {}) => {
            // verify required parameter 'passkeyChangeSettings' is not null or undefined
            common_1.assertParamExists('updatePasskey', 'passkeyChangeSettings', passkeyChangeSettings);
            const localVarPath = `/auth/passkey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(passkeyChangeSettings, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthPasskeyApi - functional programming interface
 * @export
 */
exports.AuthPasskeyApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthPasskeyApiAxiosParamCreator(configuration);
    return {
        /**
         * Resets the passkey of the account specified in the passkey reset authentification token. A new passkey and an passkey reset authentification token must be provided. This authentification token can be requested via /accounts/{accountId}/passkey-reset-request.
         * @summary createPasskeyReset - Reset the passkey of an account after receiving an reset authentification token
         * @param {ResetPasskey} resetPasskey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPasskeyReset(resetPasskey, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPasskeyReset(resetPasskey, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Creates a passkey reset request and sends a mail to the email address of the account specified in the body containing a passkey reset token that has to be provided when resetting the passkey. The passkey reset token has an expiration time.
         * @summary createPasskeyResetRequest - Create passkey reset request for a person account. Send an email to the account\'s email address 🚧 TODO - Require OTP code?!
         * @param {PasskeyResetRequest} passkeyResetRequest The passkey reset request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPasskeyResetRequest(passkeyResetRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPasskeyResetRequest(passkeyResetRequest, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Updates the passkey of the requesting account. This method is protected through an access token that has to be provided.
         * @summary updatePasskey - Update the passkey of the requesting account
         * @param {PasskeyChangeSettings} passkeyChangeSettings Old and new passkey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePasskey(passkeyChangeSettings, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePasskey(passkeyChangeSettings, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * AuthPasskeyApi - factory interface
 * @export
 */
exports.AuthPasskeyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthPasskeyApiFp(configuration);
    return {
        /**
         * Resets the passkey of the account specified in the passkey reset authentification token. A new passkey and an passkey reset authentification token must be provided. This authentification token can be requested via /accounts/{accountId}/passkey-reset-request.
         * @summary createPasskeyReset - Reset the passkey of an account after receiving an reset authentification token
         * @param {ResetPasskey} resetPasskey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasskeyReset(resetPasskey, options) {
            return localVarFp.createPasskeyReset(resetPasskey, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a passkey reset request and sends a mail to the email address of the account specified in the body containing a passkey reset token that has to be provided when resetting the passkey. The passkey reset token has an expiration time.
         * @summary createPasskeyResetRequest - Create passkey reset request for a person account. Send an email to the account\'s email address 🚧 TODO - Require OTP code?!
         * @param {PasskeyResetRequest} passkeyResetRequest The passkey reset request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasskeyResetRequest(passkeyResetRequest, options) {
            return localVarFp.createPasskeyResetRequest(passkeyResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the passkey of the requesting account. This method is protected through an access token that has to be provided.
         * @summary updatePasskey - Update the passkey of the requesting account
         * @param {PasskeyChangeSettings} passkeyChangeSettings Old and new passkey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasskey(passkeyChangeSettings, options) {
            return localVarFp.updatePasskey(passkeyChangeSettings, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthPasskeyApi - object-oriented interface
 * @export
 * @class AuthPasskeyApi
 * @extends {BaseAPI}
 */
class AuthPasskeyApi extends base_1.BaseAPI {
    /**
     * Resets the passkey of the account specified in the passkey reset authentification token. A new passkey and an passkey reset authentification token must be provided. This authentification token can be requested via /accounts/{accountId}/passkey-reset-request.
     * @summary createPasskeyReset - Reset the passkey of an account after receiving an reset authentification token
     * @param {ResetPasskey} resetPasskey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthPasskeyApi
     */
    createPasskeyReset(resetPasskey, options) {
        return exports.AuthPasskeyApiFp(this.configuration).createPasskeyReset(resetPasskey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a passkey reset request and sends a mail to the email address of the account specified in the body containing a passkey reset token that has to be provided when resetting the passkey. The passkey reset token has an expiration time.
     * @summary createPasskeyResetRequest - Create passkey reset request for a person account. Send an email to the account\'s email address 🚧 TODO - Require OTP code?!
     * @param {PasskeyResetRequest} passkeyResetRequest The passkey reset request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthPasskeyApi
     */
    createPasskeyResetRequest(passkeyResetRequest, options) {
        return exports.AuthPasskeyApiFp(this.configuration).createPasskeyResetRequest(passkeyResetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the passkey of the requesting account. This method is protected through an access token that has to be provided.
     * @summary updatePasskey - Update the passkey of the requesting account
     * @param {PasskeyChangeSettings} passkeyChangeSettings Old and new passkey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthPasskeyApi
     */
    updatePasskey(passkeyChangeSettings, options) {
        return exports.AuthPasskeyApiFp(this.configuration).updatePasskey(passkeyChangeSettings, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthPasskeyApi = AuthPasskeyApi;
/**
 * InvitationsApi - axios parameter creator
 * @export
 */
exports.InvitationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Accepts an invitation.  Associates (1) a new person account or existent account as a member with an organisation or (2) a (2a) new organisation along with a new or existent person account or (2b) an existent organisation as a child organisation with an organisation.  In case the invitation has expired this request returns with `401`. In case a person account is created a passkey reset email is sent to the email address of the account.
         * @summary acceptInvitation - Accept invitation to join an organsation with an account or with a child organisation
         * @param {InvitationAcceptance} invitationAcceptance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation: async (invitationAcceptance, options = {}) => {
            // verify required parameter 'invitationAcceptance' is not null or undefined
            common_1.assertParamExists('acceptInvitation', 'invitationAcceptance', invitationAcceptance);
            const localVarPath = `/invitations/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(invitationAcceptance, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new inviation for a person (1) to join {organisationId} with an account or (2) to join an organisation with a child organisation. An invitation token is sent to the specified email address. The invitation token has an expiration time. The requesting account must have sufficient rights to perform this operation:    * invitations, canCreate (in organisationId)    or    * organisations/all, canCreate
         * @summary createInvitation - Create invitation for person to join organisation {organisationId} with account or child organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {InvitationRequest} invitationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation: async (organisationId, invitationRequest, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('createInvitation', 'organisationId', organisationId);
            // verify required parameter 'invitationRequest' is not null or undefined
            common_1.assertParamExists('createInvitation', 'invitationRequest', invitationRequest);
            const localVarPath = `/organisations/{organisationId}/invitations`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(invitationRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * InvitationsApi - functional programming interface
 * @export
 */
exports.InvitationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.InvitationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Accepts an invitation.  Associates (1) a new person account or existent account as a member with an organisation or (2) a (2a) new organisation along with a new or existent person account or (2b) an existent organisation as a child organisation with an organisation.  In case the invitation has expired this request returns with `401`. In case a person account is created a passkey reset email is sent to the email address of the account.
         * @summary acceptInvitation - Accept invitation to join an organsation with an account or with a child organisation
         * @param {InvitationAcceptance} invitationAcceptance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvitation(invitationAcceptance, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvitation(invitationAcceptance, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Creates a new inviation for a person (1) to join {organisationId} with an account or (2) to join an organisation with a child organisation. An invitation token is sent to the specified email address. The invitation token has an expiration time. The requesting account must have sufficient rights to perform this operation:    * invitations, canCreate (in organisationId)    or    * organisations/all, canCreate
         * @summary createInvitation - Create invitation for person to join organisation {organisationId} with account or child organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {InvitationRequest} invitationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitation(organisationId, invitationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitation(organisationId, invitationRequest, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * InvitationsApi - factory interface
 * @export
 */
exports.InvitationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.InvitationsApiFp(configuration);
    return {
        /**
         * Accepts an invitation.  Associates (1) a new person account or existent account as a member with an organisation or (2) a (2a) new organisation along with a new or existent person account or (2b) an existent organisation as a child organisation with an organisation.  In case the invitation has expired this request returns with `401`. In case a person account is created a passkey reset email is sent to the email address of the account.
         * @summary acceptInvitation - Accept invitation to join an organsation with an account or with a child organisation
         * @param {InvitationAcceptance} invitationAcceptance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(invitationAcceptance, options) {
            return localVarFp.acceptInvitation(invitationAcceptance, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new inviation for a person (1) to join {organisationId} with an account or (2) to join an organisation with a child organisation. An invitation token is sent to the specified email address. The invitation token has an expiration time. The requesting account must have sufficient rights to perform this operation:    * invitations, canCreate (in organisationId)    or    * organisations/all, canCreate
         * @summary createInvitation - Create invitation for person to join organisation {organisationId} with account or child organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {InvitationRequest} invitationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(organisationId, invitationRequest, options) {
            return localVarFp.createInvitation(organisationId, invitationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InvitationsApi - object-oriented interface
 * @export
 * @class InvitationsApi
 * @extends {BaseAPI}
 */
class InvitationsApi extends base_1.BaseAPI {
    /**
     * Accepts an invitation.  Associates (1) a new person account or existent account as a member with an organisation or (2) a (2a) new organisation along with a new or existent person account or (2b) an existent organisation as a child organisation with an organisation.  In case the invitation has expired this request returns with `401`. In case a person account is created a passkey reset email is sent to the email address of the account.
     * @summary acceptInvitation - Accept invitation to join an organsation with an account or with a child organisation
     * @param {InvitationAcceptance} invitationAcceptance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    acceptInvitation(invitationAcceptance, options) {
        return exports.InvitationsApiFp(this.configuration).acceptInvitation(invitationAcceptance, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new inviation for a person (1) to join {organisationId} with an account or (2) to join an organisation with a child organisation. An invitation token is sent to the specified email address. The invitation token has an expiration time. The requesting account must have sufficient rights to perform this operation:    * invitations, canCreate (in organisationId)    or    * organisations/all, canCreate
     * @summary createInvitation - Create invitation for person to join organisation {organisationId} with account or child organisation
     * @param {string} organisationId The ID of the organisation resource
     * @param {InvitationRequest} invitationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    createInvitation(organisationId, invitationRequest, options) {
        return exports.InvitationsApiFp(this.configuration).createInvitation(organisationId, invitationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.InvitationsApi = InvitationsApi;
/**
 * OrganisationsApi - axios parameter creator
 * @export
 */
exports.OrganisationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Service method for admin purposes. Creates a new organisation. The requesting account must have sufficient rights to perform this operation.
         * @summary createOrganisation - Create organisation
         * @param {OrganisationCreate} organisationCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganisation: async (organisationCreate, options = {}) => {
            // verify required parameter 'organisationCreate' is not null or undefined
            common_1.assertParamExists('createOrganisation', 'organisationCreate', organisationCreate);
            const localVarPath = `/organisations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(organisationCreate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the organisation {organisation}. The requesting account must have sufficient rights to perform this operation. Member accounts of the organisation remain in the system without this membership.
         * @summary deleteOrganisation - Delete the organisation {organisationId} 🚧 TODO don\'t allow when accounts become membershipless?
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganisation: async (organisationId, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('deleteOrganisation', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reurn the organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   * organisations/all, canRead   or   * organisation, canRead (in organisationId)
         * @summary getOrganisation - Get organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisation: async (organisationId, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getOrganisation', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a range of organisations from the organisations collection. The requesting account must have sufficient rights to perform this operationId:    * organisations/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
         * @summary getOrganisations - Get range of organisations
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'organisationName' | 'organisationName desc' | 'street' | 'street desc' | 'city' | 'city desc' | 'postalCode' | 'postalCode desc' | 'vehicleKeeperMarking' | 'vehicleKeeperMarking desc' | 'taxNumber' | 'taxNumber desc' | 'houseNumber' | 'houseNumber desc' | 'country' | 'country desc' | 'phoneNumber' | 'phoneNumber desc' | 'taxNumber' | 'taxNumber desc' | 'postalCode' | 'postalCode desc' | 'vehicleKeeperMarking' | 'vehicleKeeperMarking asc' | 'ownerAccountName' | 'ownerAccountName desc' | 'ownerAccountFirstName' | 'ownerAccountFirstName desc' | 'ownerAccountLastName' | 'ownerAccountLastName desc' | 'createTimestamp' | 'createTimestamp desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'organisationId' | 'organisationName' | 'parentOrganisationIdRef' | 'street' | 'city' | 'country' | 'phoneNumber' | 'postalCode' | 'vehicleKeeperMarking' | 'taxNumber' | 'houseNumber'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisations: async ($search, $top, $skip, $filter, $count, $orderby, $select, options = {}) => {
            const localVarPath = `/organisations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            if ($select) {
                localVarQueryParameter['$select'] = Array.from($select).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially updates the organisation {organisationId}. The requesting account must have sufficient rights to perform this operation.
         * @summary updateOrganisation - Partially update organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {OrganisationUpdate} organisationUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisation: async (organisationId, organisationUpdate, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('updateOrganisation', 'organisationId', organisationId);
            // verify required parameter 'organisationUpdate' is not null or undefined
            common_1.assertParamExists('updateOrganisation', 'organisationUpdate', organisationUpdate);
            const localVarPath = `/organisations/{organisationId}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(organisationUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the ownership of the organisation {organisationId}. The new owner account must be member of the organisation. In case the organisation had no owner before the provided role ID is ignored. The requesting account must have sufficient rights to perform this operation: TODO
         * @summary updateOrganisationOwnership - Update the ownership of the organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {OrganisationOwnershipUpdate} organisationOwnershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisationOwnership: async (organisationId, organisationOwnershipUpdate, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('updateOrganisationOwnership', 'organisationId', organisationId);
            // verify required parameter 'organisationOwnershipUpdate' is not null or undefined
            common_1.assertParamExists('updateOrganisationOwnership', 'organisationOwnershipUpdate', organisationOwnershipUpdate);
            const localVarPath = `/organisations/{organisationId}/ownership`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(organisationOwnershipUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganisationsApi - functional programming interface
 * @export
 */
exports.OrganisationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OrganisationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Service method for admin purposes. Creates a new organisation. The requesting account must have sufficient rights to perform this operation.
         * @summary createOrganisation - Create organisation
         * @param {OrganisationCreate} organisationCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganisation(organisationCreate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganisation(organisationCreate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deletes the organisation {organisation}. The requesting account must have sufficient rights to perform this operation. Member accounts of the organisation remain in the system without this membership.
         * @summary deleteOrganisation - Delete the organisation {organisationId} 🚧 TODO don\'t allow when accounts become membershipless?
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganisation(organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganisation(organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Reurn the organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   * organisations/all, canRead   or   * organisation, canRead (in organisationId)
         * @summary getOrganisation - Get organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganisation(organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganisation(organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets a range of organisations from the organisations collection. The requesting account must have sufficient rights to perform this operationId:    * organisations/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
         * @summary getOrganisations - Get range of organisations
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'organisationName' | 'organisationName desc' | 'street' | 'street desc' | 'city' | 'city desc' | 'postalCode' | 'postalCode desc' | 'vehicleKeeperMarking' | 'vehicleKeeperMarking desc' | 'taxNumber' | 'taxNumber desc' | 'houseNumber' | 'houseNumber desc' | 'country' | 'country desc' | 'phoneNumber' | 'phoneNumber desc' | 'taxNumber' | 'taxNumber desc' | 'postalCode' | 'postalCode desc' | 'vehicleKeeperMarking' | 'vehicleKeeperMarking asc' | 'ownerAccountName' | 'ownerAccountName desc' | 'ownerAccountFirstName' | 'ownerAccountFirstName desc' | 'ownerAccountLastName' | 'ownerAccountLastName desc' | 'createTimestamp' | 'createTimestamp desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'organisationId' | 'organisationName' | 'parentOrganisationIdRef' | 'street' | 'city' | 'country' | 'phoneNumber' | 'postalCode' | 'vehicleKeeperMarking' | 'taxNumber' | 'houseNumber'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganisations($search, $top, $skip, $filter, $count, $orderby, $select, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganisations($search, $top, $skip, $filter, $count, $orderby, $select, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Partially updates the organisation {organisationId}. The requesting account must have sufficient rights to perform this operation.
         * @summary updateOrganisation - Partially update organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {OrganisationUpdate} organisationUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganisation(organisationId, organisationUpdate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganisation(organisationId, organisationUpdate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Updates the ownership of the organisation {organisationId}. The new owner account must be member of the organisation. In case the organisation had no owner before the provided role ID is ignored. The requesting account must have sufficient rights to perform this operation: TODO
         * @summary updateOrganisationOwnership - Update the ownership of the organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {OrganisationOwnershipUpdate} organisationOwnershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganisationOwnership(organisationId, organisationOwnershipUpdate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganisationOwnership(organisationId, organisationOwnershipUpdate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * OrganisationsApi - factory interface
 * @export
 */
exports.OrganisationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OrganisationsApiFp(configuration);
    return {
        /**
         * Service method for admin purposes. Creates a new organisation. The requesting account must have sufficient rights to perform this operation.
         * @summary createOrganisation - Create organisation
         * @param {OrganisationCreate} organisationCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganisation(organisationCreate, options) {
            return localVarFp.createOrganisation(organisationCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the organisation {organisation}. The requesting account must have sufficient rights to perform this operation. Member accounts of the organisation remain in the system without this membership.
         * @summary deleteOrganisation - Delete the organisation {organisationId} 🚧 TODO don\'t allow when accounts become membershipless?
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganisation(organisationId, options) {
            return localVarFp.deleteOrganisation(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reurn the organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   * organisations/all, canRead   or   * organisation, canRead (in organisationId)
         * @summary getOrganisation - Get organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisation(organisationId, options) {
            return localVarFp.getOrganisation(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a range of organisations from the organisations collection. The requesting account must have sufficient rights to perform this operationId:    * organisations/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
         * @summary getOrganisations - Get range of organisations
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'organisationName' | 'organisationName desc' | 'street' | 'street desc' | 'city' | 'city desc' | 'postalCode' | 'postalCode desc' | 'vehicleKeeperMarking' | 'vehicleKeeperMarking desc' | 'taxNumber' | 'taxNumber desc' | 'houseNumber' | 'houseNumber desc' | 'country' | 'country desc' | 'phoneNumber' | 'phoneNumber desc' | 'taxNumber' | 'taxNumber desc' | 'postalCode' | 'postalCode desc' | 'vehicleKeeperMarking' | 'vehicleKeeperMarking asc' | 'ownerAccountName' | 'ownerAccountName desc' | 'ownerAccountFirstName' | 'ownerAccountFirstName desc' | 'ownerAccountLastName' | 'ownerAccountLastName desc' | 'createTimestamp' | 'createTimestamp desc'>} [$orderby] An OData conformant $orderby string
         * @param {Array<'organisationId' | 'organisationName' | 'parentOrganisationIdRef' | 'street' | 'city' | 'country' | 'phoneNumber' | 'postalCode' | 'vehicleKeeperMarking' | 'taxNumber' | 'houseNumber'>} [$select] An OData conformant $select string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisations($search, $top, $skip, $filter, $count, $orderby, $select, options) {
            return localVarFp.getOrganisations($search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(axios, basePath));
        },
        /**
         * Partially updates the organisation {organisationId}. The requesting account must have sufficient rights to perform this operation.
         * @summary updateOrganisation - Partially update organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {OrganisationUpdate} organisationUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisation(organisationId, organisationUpdate, options) {
            return localVarFp.updateOrganisation(organisationId, organisationUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the ownership of the organisation {organisationId}. The new owner account must be member of the organisation. In case the organisation had no owner before the provided role ID is ignored. The requesting account must have sufficient rights to perform this operation: TODO
         * @summary updateOrganisationOwnership - Update the ownership of the organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {OrganisationOwnershipUpdate} organisationOwnershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganisationOwnership(organisationId, organisationOwnershipUpdate, options) {
            return localVarFp.updateOrganisationOwnership(organisationId, organisationOwnershipUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganisationsApi - object-oriented interface
 * @export
 * @class OrganisationsApi
 * @extends {BaseAPI}
 */
class OrganisationsApi extends base_1.BaseAPI {
    /**
     * Service method for admin purposes. Creates a new organisation. The requesting account must have sufficient rights to perform this operation.
     * @summary createOrganisation - Create organisation
     * @param {OrganisationCreate} organisationCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    createOrganisation(organisationCreate, options) {
        return exports.OrganisationsApiFp(this.configuration).createOrganisation(organisationCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the organisation {organisation}. The requesting account must have sufficient rights to perform this operation. Member accounts of the organisation remain in the system without this membership.
     * @summary deleteOrganisation - Delete the organisation {organisationId} 🚧 TODO don\'t allow when accounts become membershipless?
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    deleteOrganisation(organisationId, options) {
        return exports.OrganisationsApiFp(this.configuration).deleteOrganisation(organisationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Reurn the organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   * organisations/all, canRead   or   * organisation, canRead (in organisationId)
     * @summary getOrganisation - Get organisation {organisationId}
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    getOrganisation(organisationId, options) {
        return exports.OrganisationsApiFp(this.configuration).getOrganisation(organisationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a range of organisations from the organisations collection. The requesting account must have sufficient rights to perform this operationId:    * organisations/all, canRead  The visible collection is limited to the items the requesting account is allowed to access.
     * @summary getOrganisations - Get range of organisations
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Array<'organisationName' | 'organisationName desc' | 'street' | 'street desc' | 'city' | 'city desc' | 'postalCode' | 'postalCode desc' | 'vehicleKeeperMarking' | 'vehicleKeeperMarking desc' | 'taxNumber' | 'taxNumber desc' | 'houseNumber' | 'houseNumber desc' | 'country' | 'country desc' | 'phoneNumber' | 'phoneNumber desc' | 'taxNumber' | 'taxNumber desc' | 'postalCode' | 'postalCode desc' | 'vehicleKeeperMarking' | 'vehicleKeeperMarking asc' | 'ownerAccountName' | 'ownerAccountName desc' | 'ownerAccountFirstName' | 'ownerAccountFirstName desc' | 'ownerAccountLastName' | 'ownerAccountLastName desc' | 'createTimestamp' | 'createTimestamp desc'>} [$orderby] An OData conformant $orderby string
     * @param {Array<'organisationId' | 'organisationName' | 'parentOrganisationIdRef' | 'street' | 'city' | 'country' | 'phoneNumber' | 'postalCode' | 'vehicleKeeperMarking' | 'taxNumber' | 'houseNumber'>} [$select] An OData conformant $select string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    getOrganisations($search, $top, $skip, $filter, $count, $orderby, $select, options) {
        return exports.OrganisationsApiFp(this.configuration).getOrganisations($search, $top, $skip, $filter, $count, $orderby, $select, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Partially updates the organisation {organisationId}. The requesting account must have sufficient rights to perform this operation.
     * @summary updateOrganisation - Partially update organisation {organisationId}
     * @param {string} organisationId The ID of the organisation resource
     * @param {OrganisationUpdate} organisationUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    updateOrganisation(organisationId, organisationUpdate, options) {
        return exports.OrganisationsApiFp(this.configuration).updateOrganisation(organisationId, organisationUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the ownership of the organisation {organisationId}. The new owner account must be member of the organisation. In case the organisation had no owner before the provided role ID is ignored. The requesting account must have sufficient rights to perform this operation: TODO
     * @summary updateOrganisationOwnership - Update the ownership of the organisation
     * @param {string} organisationId The ID of the organisation resource
     * @param {OrganisationOwnershipUpdate} organisationOwnershipUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsApi
     */
    updateOrganisationOwnership(organisationId, organisationOwnershipUpdate, options) {
        return exports.OrganisationsApiFp(this.configuration).updateOrganisationOwnership(organisationId, organisationOwnershipUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrganisationsApi = OrganisationsApi;
/**
 * OrganisationsAccessRightsApi - axios parameter creator
 * @export
 */
exports.OrganisationsAccessRightsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets the detailed access rights of organisation {organisationId}. The access rights are ordered by the organisation IDs the organisation is child of. The access rights may vary across the parent organisations. In case {organisationId} is NRail the issuing organisation is NRail itself. The requesting account must have sufficient rights to perform this operation:    * organisations/all, canRead   or   * organisation, canRead (in {organisationId})
         * @summary getOrganisationAccessRights - Get the access rights of the organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisationAccessRights: async (organisationId, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getOrganisationAccessRights', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/access-rights`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganisationsAccessRightsApi - functional programming interface
 * @export
 */
exports.OrganisationsAccessRightsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OrganisationsAccessRightsApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets the detailed access rights of organisation {organisationId}. The access rights are ordered by the organisation IDs the organisation is child of. The access rights may vary across the parent organisations. In case {organisationId} is NRail the issuing organisation is NRail itself. The requesting account must have sufficient rights to perform this operation:    * organisations/all, canRead   or   * organisation, canRead (in {organisationId})
         * @summary getOrganisationAccessRights - Get the access rights of the organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganisationAccessRights(organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganisationAccessRights(organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * OrganisationsAccessRightsApi - factory interface
 * @export
 */
exports.OrganisationsAccessRightsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OrganisationsAccessRightsApiFp(configuration);
    return {
        /**
         * Gets the detailed access rights of organisation {organisationId}. The access rights are ordered by the organisation IDs the organisation is child of. The access rights may vary across the parent organisations. In case {organisationId} is NRail the issuing organisation is NRail itself. The requesting account must have sufficient rights to perform this operation:    * organisations/all, canRead   or   * organisation, canRead (in {organisationId})
         * @summary getOrganisationAccessRights - Get the access rights of the organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisationAccessRights(organisationId, options) {
            return localVarFp.getOrganisationAccessRights(organisationId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganisationsAccessRightsApi - object-oriented interface
 * @export
 * @class OrganisationsAccessRightsApi
 * @extends {BaseAPI}
 */
class OrganisationsAccessRightsApi extends base_1.BaseAPI {
    /**
     * Gets the detailed access rights of organisation {organisationId}. The access rights are ordered by the organisation IDs the organisation is child of. The access rights may vary across the parent organisations. In case {organisationId} is NRail the issuing organisation is NRail itself. The requesting account must have sufficient rights to perform this operation:    * organisations/all, canRead   or   * organisation, canRead (in {organisationId})
     * @summary getOrganisationAccessRights - Get the access rights of the organisation
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsAccessRightsApi
     */
    getOrganisationAccessRights(organisationId, options) {
        return exports.OrganisationsAccessRightsApiFp(this.configuration).getOrganisationAccessRights(organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrganisationsAccessRightsApi = OrganisationsAccessRightsApi;
/**
 * OrganisationsChildrenApi - axios parameter creator
 * @export
 */
exports.OrganisationsChildrenApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Add the role assingments assigned by {organisationId} to child organisation {childOrganisationId}. The requesting account must have sufficient rights to perform this operation.
         * @summary addChildOrganisationRoleAssignment - Add the role assignments assigned by {organisationId} to child organisation {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChildOrganisationRoleAssignment: async (organisationId, childOrganisationId, roleResourceCombination, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('addChildOrganisationRoleAssignment', 'organisationId', organisationId);
            // verify required parameter 'childOrganisationId' is not null or undefined
            common_1.assertParamExists('addChildOrganisationRoleAssignment', 'childOrganisationId', childOrganisationId);
            // verify required parameter 'roleResourceCombination' is not null or undefined
            common_1.assertParamExists('addChildOrganisationRoleAssignment', 'roleResourceCombination', roleResourceCombination);
            const localVarPath = `/organisations/{organisationId}/child-organisations/{childOrganisationId}/role-assignments`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"childOrganisationId"}}`, encodeURIComponent(String(childOrganisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleResourceCombination, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the relationship of {organisationId} to the child organisations {childOrganisationId}. The requesting account must have sufficient rights to perform this operation.
         * @summary deleteChildOrganisationRelationship - Delete the relationship of {organisationId} to the child organisations {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {DeleteRelationshipRequest} deleteRelationshipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChildOrganisationRelationship: async (organisationId, childOrganisationId, deleteRelationshipRequest, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('deleteChildOrganisationRelationship', 'organisationId', organisationId);
            // verify required parameter 'childOrganisationId' is not null or undefined
            common_1.assertParamExists('deleteChildOrganisationRelationship', 'childOrganisationId', childOrganisationId);
            // verify required parameter 'deleteRelationshipRequest' is not null or undefined
            common_1.assertParamExists('deleteChildOrganisationRelationship', 'deleteRelationshipRequest', deleteRelationshipRequest);
            const localVarPath = `/organisations/{organisationId}/child-organisations/{childOrganisationId}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"childOrganisationId"}}`, encodeURIComponent(String(childOrganisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deleteRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete role assignment assigned by {organisationId} to child organisation {childOrganisationId}. Both role id and resource id must match. The requesting account must have sufficient rights to perform this operation.
         * @summary deleteChildOrganisationRoleAssignment - Delete role assignment assigned by {organisationId} to child organisation {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChildOrganisationRoleAssignment: async (organisationId, childOrganisationId, roleResourceCombination, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('deleteChildOrganisationRoleAssignment', 'organisationId', organisationId);
            // verify required parameter 'childOrganisationId' is not null or undefined
            common_1.assertParamExists('deleteChildOrganisationRoleAssignment', 'childOrganisationId', childOrganisationId);
            // verify required parameter 'roleResourceCombination' is not null or undefined
            common_1.assertParamExists('deleteChildOrganisationRoleAssignment', 'roleResourceCombination', roleResourceCombination);
            const localVarPath = `/organisations/{organisationId}/child-organisations/{childOrganisationId}/role-assignments`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"childOrganisationId"}}`, encodeURIComponent(String(childOrganisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleResourceCombination, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the role/resource assingments assigned by {organisationId} to child organisation {childOrganisationId}. The requesting account must have sufficient rights to perform this operation:   organisation, canRead (in {organisationId})   organisations/all, canRead
         * @summary getChildOrganisationRoleAssignments - Get the role/resource assignments assigned by {organisationId} to child organisation {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildOrganisationRoleAssignments: async (organisationId, childOrganisationId, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getChildOrganisationRoleAssignments', 'organisationId', organisationId);
            // verify required parameter 'childOrganisationId' is not null or undefined
            common_1.assertParamExists('getChildOrganisationRoleAssignments', 'childOrganisationId', childOrganisationId);
            const localVarPath = `/organisations/{organisationId}/child-organisations/{childOrganisationId}/role-assignments`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"childOrganisationId"}}`, encodeURIComponent(String(childOrganisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets child organisations of organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   organisation, canRead (in {organisationId})   organisations/all, canRead
         * @summary getChildOrganisations - Get the child organisations of organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildOrganisations: async (organisationId, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getChildOrganisations', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/child-organisations`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganisationsChildrenApi - functional programming interface
 * @export
 */
exports.OrganisationsChildrenApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OrganisationsChildrenApiAxiosParamCreator(configuration);
    return {
        /**
         * Add the role assingments assigned by {organisationId} to child organisation {childOrganisationId}. The requesting account must have sufficient rights to perform this operation.
         * @summary addChildOrganisationRoleAssignment - Add the role assignments assigned by {organisationId} to child organisation {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Delete the relationship of {organisationId} to the child organisations {childOrganisationId}. The requesting account must have sufficient rights to perform this operation.
         * @summary deleteChildOrganisationRelationship - Delete the relationship of {organisationId} to the child organisations {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {DeleteRelationshipRequest} deleteRelationshipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChildOrganisationRelationship(organisationId, childOrganisationId, deleteRelationshipRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChildOrganisationRelationship(organisationId, childOrganisationId, deleteRelationshipRequest, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Delete role assignment assigned by {organisationId} to child organisation {childOrganisationId}. Both role id and resource id must match. The requesting account must have sufficient rights to perform this operation.
         * @summary deleteChildOrganisationRoleAssignment - Delete role assignment assigned by {organisationId} to child organisation {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get the role/resource assingments assigned by {organisationId} to child organisation {childOrganisationId}. The requesting account must have sufficient rights to perform this operation:   organisation, canRead (in {organisationId})   organisations/all, canRead
         * @summary getChildOrganisationRoleAssignments - Get the role/resource assignments assigned by {organisationId} to child organisation {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChildOrganisationRoleAssignments(organisationId, childOrganisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChildOrganisationRoleAssignments(organisationId, childOrganisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets child organisations of organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   organisation, canRead (in {organisationId})   organisations/all, canRead
         * @summary getChildOrganisations - Get the child organisations of organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChildOrganisations(organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChildOrganisations(organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * OrganisationsChildrenApi - factory interface
 * @export
 */
exports.OrganisationsChildrenApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OrganisationsChildrenApiFp(configuration);
    return {
        /**
         * Add the role assingments assigned by {organisationId} to child organisation {childOrganisationId}. The requesting account must have sufficient rights to perform this operation.
         * @summary addChildOrganisationRoleAssignment - Add the role assignments assigned by {organisationId} to child organisation {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options) {
            return localVarFp.addChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the relationship of {organisationId} to the child organisations {childOrganisationId}. The requesting account must have sufficient rights to perform this operation.
         * @summary deleteChildOrganisationRelationship - Delete the relationship of {organisationId} to the child organisations {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {DeleteRelationshipRequest} deleteRelationshipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChildOrganisationRelationship(organisationId, childOrganisationId, deleteRelationshipRequest, options) {
            return localVarFp.deleteChildOrganisationRelationship(organisationId, childOrganisationId, deleteRelationshipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete role assignment assigned by {organisationId} to child organisation {childOrganisationId}. Both role id and resource id must match. The requesting account must have sufficient rights to perform this operation.
         * @summary deleteChildOrganisationRoleAssignment - Delete role assignment assigned by {organisationId} to child organisation {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {RoleResourceCombination} roleResourceCombination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options) {
            return localVarFp.deleteChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the role/resource assingments assigned by {organisationId} to child organisation {childOrganisationId}. The requesting account must have sufficient rights to perform this operation:   organisation, canRead (in {organisationId})   organisations/all, canRead
         * @summary getChildOrganisationRoleAssignments - Get the role/resource assignments assigned by {organisationId} to child organisation {childOrganisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} childOrganisationId The ID of the child organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildOrganisationRoleAssignments(organisationId, childOrganisationId, options) {
            return localVarFp.getChildOrganisationRoleAssignments(organisationId, childOrganisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets child organisations of organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   organisation, canRead (in {organisationId})   organisations/all, canRead
         * @summary getChildOrganisations - Get the child organisations of organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildOrganisations(organisationId, options) {
            return localVarFp.getChildOrganisations(organisationId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganisationsChildrenApi - object-oriented interface
 * @export
 * @class OrganisationsChildrenApi
 * @extends {BaseAPI}
 */
class OrganisationsChildrenApi extends base_1.BaseAPI {
    /**
     * Add the role assingments assigned by {organisationId} to child organisation {childOrganisationId}. The requesting account must have sufficient rights to perform this operation.
     * @summary addChildOrganisationRoleAssignment - Add the role assignments assigned by {organisationId} to child organisation {childOrganisationId}
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} childOrganisationId The ID of the child organisation resource
     * @param {RoleResourceCombination} roleResourceCombination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsChildrenApi
     */
    addChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options) {
        return exports.OrganisationsChildrenApiFp(this.configuration).addChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete the relationship of {organisationId} to the child organisations {childOrganisationId}. The requesting account must have sufficient rights to perform this operation.
     * @summary deleteChildOrganisationRelationship - Delete the relationship of {organisationId} to the child organisations {childOrganisationId}
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} childOrganisationId The ID of the child organisation resource
     * @param {DeleteRelationshipRequest} deleteRelationshipRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsChildrenApi
     */
    deleteChildOrganisationRelationship(organisationId, childOrganisationId, deleteRelationshipRequest, options) {
        return exports.OrganisationsChildrenApiFp(this.configuration).deleteChildOrganisationRelationship(organisationId, childOrganisationId, deleteRelationshipRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete role assignment assigned by {organisationId} to child organisation {childOrganisationId}. Both role id and resource id must match. The requesting account must have sufficient rights to perform this operation.
     * @summary deleteChildOrganisationRoleAssignment - Delete role assignment assigned by {organisationId} to child organisation {childOrganisationId}
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} childOrganisationId The ID of the child organisation resource
     * @param {RoleResourceCombination} roleResourceCombination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsChildrenApi
     */
    deleteChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options) {
        return exports.OrganisationsChildrenApiFp(this.configuration).deleteChildOrganisationRoleAssignment(organisationId, childOrganisationId, roleResourceCombination, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the role/resource assingments assigned by {organisationId} to child organisation {childOrganisationId}. The requesting account must have sufficient rights to perform this operation:   organisation, canRead (in {organisationId})   organisations/all, canRead
     * @summary getChildOrganisationRoleAssignments - Get the role/resource assignments assigned by {organisationId} to child organisation {childOrganisationId}
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} childOrganisationId The ID of the child organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsChildrenApi
     */
    getChildOrganisationRoleAssignments(organisationId, childOrganisationId, options) {
        return exports.OrganisationsChildrenApiFp(this.configuration).getChildOrganisationRoleAssignments(organisationId, childOrganisationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets child organisations of organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   organisation, canRead (in {organisationId})   organisations/all, canRead
     * @summary getChildOrganisations - Get the child organisations of organisation {organisationId}
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsChildrenApi
     */
    getChildOrganisations(organisationId, options) {
        return exports.OrganisationsChildrenApiFp(this.configuration).getChildOrganisations(organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrganisationsChildrenApi = OrganisationsChildrenApi;
/**
 * OrganisationsMergerApi - axios parameter creator
 * @export
 */
exports.OrganisationsMergerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Merges a mergee organisation into merger organisation {organisationId}. The owner account of {organisationId} will be the owner of the resulting organisation. The accounts from the mergee organisation will become accounts of the resulting organisation. An access token for an authorized account from the mergee organisation must be provided in the body.
         * @summary mergeOrganisationIntoOrganisation - Merge an organisation into organisation {organisationId} 🚧
         * @param {string} organisationId The ID of the organisation resource
         * @param {OrganisationMergerInfo} organisationMergerInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeOrganisationIntoOrganisation: async (organisationId, organisationMergerInfo, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('mergeOrganisationIntoOrganisation', 'organisationId', organisationId);
            // verify required parameter 'organisationMergerInfo' is not null or undefined
            common_1.assertParamExists('mergeOrganisationIntoOrganisation', 'organisationMergerInfo', organisationMergerInfo);
            const localVarPath = `/organisations/{organisationId}/merger`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(organisationMergerInfo, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganisationsMergerApi - functional programming interface
 * @export
 */
exports.OrganisationsMergerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OrganisationsMergerApiAxiosParamCreator(configuration);
    return {
        /**
         * Merges a mergee organisation into merger organisation {organisationId}. The owner account of {organisationId} will be the owner of the resulting organisation. The accounts from the mergee organisation will become accounts of the resulting organisation. An access token for an authorized account from the mergee organisation must be provided in the body.
         * @summary mergeOrganisationIntoOrganisation - Merge an organisation into organisation {organisationId} 🚧
         * @param {string} organisationId The ID of the organisation resource
         * @param {OrganisationMergerInfo} organisationMergerInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeOrganisationIntoOrganisation(organisationId, organisationMergerInfo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeOrganisationIntoOrganisation(organisationId, organisationMergerInfo, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * OrganisationsMergerApi - factory interface
 * @export
 */
exports.OrganisationsMergerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OrganisationsMergerApiFp(configuration);
    return {
        /**
         * Merges a mergee organisation into merger organisation {organisationId}. The owner account of {organisationId} will be the owner of the resulting organisation. The accounts from the mergee organisation will become accounts of the resulting organisation. An access token for an authorized account from the mergee organisation must be provided in the body.
         * @summary mergeOrganisationIntoOrganisation - Merge an organisation into organisation {organisationId} 🚧
         * @param {string} organisationId The ID of the organisation resource
         * @param {OrganisationMergerInfo} organisationMergerInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeOrganisationIntoOrganisation(organisationId, organisationMergerInfo, options) {
            return localVarFp.mergeOrganisationIntoOrganisation(organisationId, organisationMergerInfo, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganisationsMergerApi - object-oriented interface
 * @export
 * @class OrganisationsMergerApi
 * @extends {BaseAPI}
 */
class OrganisationsMergerApi extends base_1.BaseAPI {
    /**
     * Merges a mergee organisation into merger organisation {organisationId}. The owner account of {organisationId} will be the owner of the resulting organisation. The accounts from the mergee organisation will become accounts of the resulting organisation. An access token for an authorized account from the mergee organisation must be provided in the body.
     * @summary mergeOrganisationIntoOrganisation - Merge an organisation into organisation {organisationId} 🚧
     * @param {string} organisationId The ID of the organisation resource
     * @param {OrganisationMergerInfo} organisationMergerInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsMergerApi
     */
    mergeOrganisationIntoOrganisation(organisationId, organisationMergerInfo, options) {
        return exports.OrganisationsMergerApiFp(this.configuration).mergeOrganisationIntoOrganisation(organisationId, organisationMergerInfo, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrganisationsMergerApi = OrganisationsMergerApi;
/**
 * OrganisationsParentsApi - axios parameter creator
 * @export
 */
exports.OrganisationsParentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets parent organisations of organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   parent_organisations, canRead (in {organisationId})   organisations/all, canRead
         * @summary getParentOrganisations - Get the parent organisations of organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentOrganisations: async (organisationId, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getParentOrganisations', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/parent-organisations`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganisationsParentsApi - functional programming interface
 * @export
 */
exports.OrganisationsParentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OrganisationsParentsApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets parent organisations of organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   parent_organisations, canRead (in {organisationId})   organisations/all, canRead
         * @summary getParentOrganisations - Get the parent organisations of organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParentOrganisations(organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParentOrganisations(organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * OrganisationsParentsApi - factory interface
 * @export
 */
exports.OrganisationsParentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OrganisationsParentsApiFp(configuration);
    return {
        /**
         * Gets parent organisations of organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   parent_organisations, canRead (in {organisationId})   organisations/all, canRead
         * @summary getParentOrganisations - Get the parent organisations of organisation {organisationId}
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentOrganisations(organisationId, options) {
            return localVarFp.getParentOrganisations(organisationId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganisationsParentsApi - object-oriented interface
 * @export
 * @class OrganisationsParentsApi
 * @extends {BaseAPI}
 */
class OrganisationsParentsApi extends base_1.BaseAPI {
    /**
     * Gets parent organisations of organisation {organisationId}. The requesting account must have sufficient rights to perform this operation:   parent_organisations, canRead (in {organisationId})   organisations/all, canRead
     * @summary getParentOrganisations - Get the parent organisations of organisation {organisationId}
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationsParentsApi
     */
    getParentOrganisations(organisationId, options) {
        return exports.OrganisationsParentsApiFp(this.configuration).getParentOrganisations(organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrganisationsParentsApi = OrganisationsParentsApi;
/**
 * ResourceGroupsApi - axios parameter creator
 * @export
 */
exports.ResourceGroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns multiple resources. Requesting user must have sufficiant access rights:   READ ON resources/all -> all resources in organisation are visible.
         * @summary getAccountResourcesInOrganisation - Get multiple resources for an account in organisation
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountResourcesInOrganisation: async (accountId, organisationId, $search, $top, $skip, $filter, $count, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getAccountResourcesInOrganisation', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getAccountResourcesInOrganisation', 'organisationId', organisationId);
            const localVarPath = `/accounts/{accountId}/organisations/{organisationId}/resources`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns multiple resources. Requesting user must have sufficiant access rights:   READ ON resources/all -> all resources in organisation are visible.
         * @summary getAccountResourcesInOrganisation - Get multiple resources for an account in organisation
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountResourcesInOrganisationUnsecured: async (accountId, organisationId, $search, $top, $skip, $filter, $count, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getAccountResourcesInOrganisationUnsecured', 'accountId', accountId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getAccountResourcesInOrganisationUnsecured', 'organisationId', organisationId);
            const localVarPath = `/internal/accounts/{accountId}/organisations/{organisationId}/resources`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns multiple resources. Requesting user must have sufficiant access rights. READ ON resources -> all resources in organisation are visible. READ ON resources/all -> all resources in organisation are visible. READ ON vehicles -> all vehicles in organisation are visible. READ ON vehicles / constrained to resources -> constrained vehicles in organisation are visible. READ ON vehicles/all -> all vehicles in organisation are visible.
         * @summary getResourcesInOrganisation - Get multiple resources in organisation ❌
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesInOrganisation: async (organisationId, $search, $top, $skip, $filter, $count, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getResourcesInOrganisation', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/resources`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ResourceGroupsApi - functional programming interface
 * @export
 */
exports.ResourceGroupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ResourceGroupsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns multiple resources. Requesting user must have sufficiant access rights:   READ ON resources/all -> all resources in organisation are visible.
         * @summary getAccountResourcesInOrganisation - Get multiple resources for an account in organisation
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountResourcesInOrganisation(accountId, organisationId, $search, $top, $skip, $filter, $count, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountResourcesInOrganisation(accountId, organisationId, $search, $top, $skip, $filter, $count, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Returns multiple resources. Requesting user must have sufficiant access rights:   READ ON resources/all -> all resources in organisation are visible.
         * @summary getAccountResourcesInOrganisation - Get multiple resources for an account in organisation
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountResourcesInOrganisationUnsecured(accountId, organisationId, $search, $top, $skip, $filter, $count, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountResourcesInOrganisationUnsecured(accountId, organisationId, $search, $top, $skip, $filter, $count, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Returns multiple resources. Requesting user must have sufficiant access rights. READ ON resources -> all resources in organisation are visible. READ ON resources/all -> all resources in organisation are visible. READ ON vehicles -> all vehicles in organisation are visible. READ ON vehicles / constrained to resources -> constrained vehicles in organisation are visible. READ ON vehicles/all -> all vehicles in organisation are visible.
         * @summary getResourcesInOrganisation - Get multiple resources in organisation ❌
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResourcesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResourcesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * ResourceGroupsApi - factory interface
 * @export
 */
exports.ResourceGroupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ResourceGroupsApiFp(configuration);
    return {
        /**
         * Returns multiple resources. Requesting user must have sufficiant access rights:   READ ON resources/all -> all resources in organisation are visible.
         * @summary getAccountResourcesInOrganisation - Get multiple resources for an account in organisation
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountResourcesInOrganisation(accountId, organisationId, $search, $top, $skip, $filter, $count, options) {
            return localVarFp.getAccountResourcesInOrganisation(accountId, organisationId, $search, $top, $skip, $filter, $count, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns multiple resources. Requesting user must have sufficiant access rights:   READ ON resources/all -> all resources in organisation are visible.
         * @summary getAccountResourcesInOrganisation - Get multiple resources for an account in organisation
         * @param {string} accountId The ID of the account resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountResourcesInOrganisationUnsecured(accountId, organisationId, $search, $top, $skip, $filter, $count, options) {
            return localVarFp.getAccountResourcesInOrganisationUnsecured(accountId, organisationId, $search, $top, $skip, $filter, $count, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns multiple resources. Requesting user must have sufficiant access rights. READ ON resources -> all resources in organisation are visible. READ ON resources/all -> all resources in organisation are visible. READ ON vehicles -> all vehicles in organisation are visible. READ ON vehicles / constrained to resources -> constrained vehicles in organisation are visible. READ ON vehicles/all -> all vehicles in organisation are visible.
         * @summary getResourcesInOrganisation - Get multiple resources in organisation ❌
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, options) {
            return localVarFp.getResourcesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ResourceGroupsApi - object-oriented interface
 * @export
 * @class ResourceGroupsApi
 * @extends {BaseAPI}
 */
class ResourceGroupsApi extends base_1.BaseAPI {
    /**
     * Returns multiple resources. Requesting user must have sufficiant access rights:   READ ON resources/all -> all resources in organisation are visible.
     * @summary getAccountResourcesInOrganisation - Get multiple resources for an account in organisation
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceGroupsApi
     */
    getAccountResourcesInOrganisation(accountId, organisationId, $search, $top, $skip, $filter, $count, options) {
        return exports.ResourceGroupsApiFp(this.configuration).getAccountResourcesInOrganisation(accountId, organisationId, $search, $top, $skip, $filter, $count, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns multiple resources. Requesting user must have sufficiant access rights:   READ ON resources/all -> all resources in organisation are visible.
     * @summary getAccountResourcesInOrganisation - Get multiple resources for an account in organisation
     * @param {string} accountId The ID of the account resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceGroupsApi
     */
    getAccountResourcesInOrganisationUnsecured(accountId, organisationId, $search, $top, $skip, $filter, $count, options) {
        return exports.ResourceGroupsApiFp(this.configuration).getAccountResourcesInOrganisationUnsecured(accountId, organisationId, $search, $top, $skip, $filter, $count, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns multiple resources. Requesting user must have sufficiant access rights. READ ON resources -> all resources in organisation are visible. READ ON resources/all -> all resources in organisation are visible. READ ON vehicles -> all vehicles in organisation are visible. READ ON vehicles / constrained to resources -> constrained vehicles in organisation are visible. READ ON vehicles/all -> all vehicles in organisation are visible.
     * @summary getResourcesInOrganisation - Get multiple resources in organisation ❌
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceGroupsApi
     */
    getResourcesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, options) {
        return exports.ResourceGroupsApiFp(this.configuration).getResourcesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ResourceGroupsApi = ResourceGroupsApi;
/**
 * RightsObjectsApi - axios parameter creator
 * @export
 */
exports.RightsObjectsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets a range of rights objects from the rights objects collection. The visible collection is limited to the items the requesting account is allowed to access. The requesting account must have sufficient rights to perform this operation.
         * @summary getRightsObjects - Get range of rights objects
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {Array<'rightsObjectName' | 'rightsObjectName desc'>} [$orderby] An OData conformant orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRightsObjects: async ($search, $top, $skip, $count, $filter, $orderby, options = {}) => {
            const localVarPath = `/rights-objects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RightsObjectsApi - functional programming interface
 * @export
 */
exports.RightsObjectsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.RightsObjectsApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets a range of rights objects from the rights objects collection. The visible collection is limited to the items the requesting account is allowed to access. The requesting account must have sufficient rights to perform this operation.
         * @summary getRightsObjects - Get range of rights objects
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {Array<'rightsObjectName' | 'rightsObjectName desc'>} [$orderby] An OData conformant orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRightsObjects($search, $top, $skip, $count, $filter, $orderby, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRightsObjects($search, $top, $skip, $count, $filter, $orderby, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * RightsObjectsApi - factory interface
 * @export
 */
exports.RightsObjectsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.RightsObjectsApiFp(configuration);
    return {
        /**
         * Gets a range of rights objects from the rights objects collection. The visible collection is limited to the items the requesting account is allowed to access. The requesting account must have sufficient rights to perform this operation.
         * @summary getRightsObjects - Get range of rights objects
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {Array<'rightsObjectName' | 'rightsObjectName desc'>} [$orderby] An OData conformant orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRightsObjects($search, $top, $skip, $count, $filter, $orderby, options) {
            return localVarFp.getRightsObjects($search, $top, $skip, $count, $filter, $orderby, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RightsObjectsApi - object-oriented interface
 * @export
 * @class RightsObjectsApi
 * @extends {BaseAPI}
 */
class RightsObjectsApi extends base_1.BaseAPI {
    /**
     * Gets a range of rights objects from the rights objects collection. The visible collection is limited to the items the requesting account is allowed to access. The requesting account must have sufficient rights to perform this operation.
     * @summary getRightsObjects - Get range of rights objects
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {Array<'rightsObjectName' | 'rightsObjectName desc'>} [$orderby] An OData conformant orderby string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsObjectsApi
     */
    getRightsObjects($search, $top, $skip, $count, $filter, $orderby, options) {
        return exports.RightsObjectsApiFp(this.configuration).getRightsObjects($search, $top, $skip, $count, $filter, $orderby, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RightsObjectsApi = RightsObjectsApi;
/**
 * RolesApi - axios parameter creator
 * @export
 */
exports.RolesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates a new role in a given organisation. The requesting account may have to be associated with the specified organisation depending on the access rights of the requesting account. An arbitrary organisation requires special access rights. The name of the role must be unique in the specified organisation. The requesting account must have sufficient rights to perform this operation.
         * @summary createRoleInOrganisation - Create role in organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleCreate} roleCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleInOrganisation: async (organisationId, roleCreate, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('createRoleInOrganisation', 'organisationId', organisationId);
            // verify required parameter 'roleCreate' is not null or undefined
            common_1.assertParamExists('createRoleInOrganisation', 'roleCreate', roleCreate);
            const localVarPath = `/organisations/{organisationId}/roles`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleCreate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes role {roleId}. The requesting account must have sufficient rights to perform this operation. Roles that are assigned to accounts cannot be deleted.
         * @summary deleteRole - Delete role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: async (roleId, options = {}) => {
            // verify required parameter 'roleId' is not null or undefined
            common_1.assertParamExists('deleteRole', 'roleId', roleId);
            const localVarPath = `/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the collection of access rights sets associated with role {roleId}. The requesting account must have sufficient rights to perform this operation:   * roles, canRead (in {organisationId})   or   * roles/all, canRead
         * @summary getRoleAccessRights - Get access rights associated with role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleAccessRights: async (roleId, organisationId, options = {}) => {
            // verify required parameter 'roleId' is not null or undefined
            common_1.assertParamExists('getRoleAccessRights', 'roleId', roleId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getRoleAccessRights', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/roles/{roleId}/access-rights`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a range of roles from the all roles collection. The requesting account must have sufficient rights to perform this operation:   roles/all, canRead
         * @summary getRoles - Get range of roles
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'roleName' | 'roleName desc'>} [$orderby] An OData conformant orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async ($search, $top, $skip, $filter, $count, $orderby, options = {}) => {
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a range of roles from the all roles collection in a given organisation. The requesting account must have sufficient rights to perform this operation. The visible collection is limited to the items the requesting account is allowed to access:   roles/all, canRead   roles, canRead (in organisationId)
         * @summary getRolesInOrganisation - Get range of roles
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'roleName' | 'roleName desc'>} [$orderby] An OData conformant orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesInOrganisation: async (organisationId, $search, $top, $skip, $filter, $count, $orderby, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getRolesInOrganisation', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/roles`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($search !== undefined) {
                localVarQueryParameter['$search'] = $search;
            }
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially updates the role {roleId}. The requesting account must have sufficient rights to perform this operation.
         * @summary updateRole - Partially update the role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {RoleUpdate} roleUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (roleId, roleUpdate, options = {}) => {
            // verify required parameter 'roleId' is not null or undefined
            common_1.assertParamExists('updateRole', 'roleId', roleId);
            // verify required parameter 'roleUpdate' is not null or undefined
            common_1.assertParamExists('updateRole', 'roleUpdate', roleUpdate);
            const localVarPath = `/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assigns access rights set to the existing role {roleId}. The access rights of role {roleID } on one rights object listed in the body are overwritten. To remove access rights on a rights object it must be listed in the body with the access rights set to false. The requesting account must have sufficient rights to perform this operation:   * roles, canUpdate (in {organisationId})   or   * roles/all, canUpdate
         * @summary updateRoleAccessRights - Assign access rights to role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {MultipleRightsObjectRightsAssociationUpdate} multipleRightsObjectRightsAssociationUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleAccessRights: async (roleId, organisationId, multipleRightsObjectRightsAssociationUpdate, options = {}) => {
            // verify required parameter 'roleId' is not null or undefined
            common_1.assertParamExists('updateRoleAccessRights', 'roleId', roleId);
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('updateRoleAccessRights', 'organisationId', organisationId);
            // verify required parameter 'multipleRightsObjectRightsAssociationUpdate' is not null or undefined
            common_1.assertParamExists('updateRoleAccessRights', 'multipleRightsObjectRightsAssociationUpdate', multipleRightsObjectRightsAssociationUpdate);
            const localVarPath = `/organisations/{organisationId}/roles/{roleId}/access-rights`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(multipleRightsObjectRightsAssociationUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RolesApi - functional programming interface
 * @export
 */
exports.RolesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.RolesApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a new role in a given organisation. The requesting account may have to be associated with the specified organisation depending on the access rights of the requesting account. An arbitrary organisation requires special access rights. The name of the role must be unique in the specified organisation. The requesting account must have sufficient rights to perform this operation.
         * @summary createRoleInOrganisation - Create role in organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleCreate} roleCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoleInOrganisation(organisationId, roleCreate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoleInOrganisation(organisationId, roleCreate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Deletes role {roleId}. The requesting account must have sufficient rights to perform this operation. Roles that are assigned to accounts cannot be deleted.
         * @summary deleteRole - Delete role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRole(roleId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRole(roleId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets the collection of access rights sets associated with role {roleId}. The requesting account must have sufficient rights to perform this operation:   * roles, canRead (in {organisationId})   or   * roles/all, canRead
         * @summary getRoleAccessRights - Get access rights associated with role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoleAccessRights(roleId, organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoleAccessRights(roleId, organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets a range of roles from the all roles collection. The requesting account must have sufficient rights to perform this operation:   roles/all, canRead
         * @summary getRoles - Get range of roles
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'roleName' | 'roleName desc'>} [$orderby] An OData conformant orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles($search, $top, $skip, $filter, $count, $orderby, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles($search, $top, $skip, $filter, $count, $orderby, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets a range of roles from the all roles collection in a given organisation. The requesting account must have sufficient rights to perform this operation. The visible collection is limited to the items the requesting account is allowed to access:   roles/all, canRead   roles, canRead (in organisationId)
         * @summary getRolesInOrganisation - Get range of roles
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'roleName' | 'roleName desc'>} [$orderby] An OData conformant orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Partially updates the role {roleId}. The requesting account must have sufficient rights to perform this operation.
         * @summary updateRole - Partially update the role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {RoleUpdate} roleUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(roleId, roleUpdate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(roleId, roleUpdate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Assigns access rights set to the existing role {roleId}. The access rights of role {roleID } on one rights object listed in the body are overwritten. To remove access rights on a rights object it must be listed in the body with the access rights set to false. The requesting account must have sufficient rights to perform this operation:   * roles, canUpdate (in {organisationId})   or   * roles/all, canUpdate
         * @summary updateRoleAccessRights - Assign access rights to role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {MultipleRightsObjectRightsAssociationUpdate} multipleRightsObjectRightsAssociationUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoleAccessRights(roleId, organisationId, multipleRightsObjectRightsAssociationUpdate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoleAccessRights(roleId, organisationId, multipleRightsObjectRightsAssociationUpdate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * RolesApi - factory interface
 * @export
 */
exports.RolesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.RolesApiFp(configuration);
    return {
        /**
         * Creates a new role in a given organisation. The requesting account may have to be associated with the specified organisation depending on the access rights of the requesting account. An arbitrary organisation requires special access rights. The name of the role must be unique in the specified organisation. The requesting account must have sufficient rights to perform this operation.
         * @summary createRoleInOrganisation - Create role in organisation
         * @param {string} organisationId The ID of the organisation resource
         * @param {RoleCreate} roleCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleInOrganisation(organisationId, roleCreate, options) {
            return localVarFp.createRoleInOrganisation(organisationId, roleCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes role {roleId}. The requesting account must have sufficient rights to perform this operation. Roles that are assigned to accounts cannot be deleted.
         * @summary deleteRole - Delete role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(roleId, options) {
            return localVarFp.deleteRole(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the collection of access rights sets associated with role {roleId}. The requesting account must have sufficient rights to perform this operation:   * roles, canRead (in {organisationId})   or   * roles/all, canRead
         * @summary getRoleAccessRights - Get access rights associated with role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleAccessRights(roleId, organisationId, options) {
            return localVarFp.getRoleAccessRights(roleId, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a range of roles from the all roles collection. The requesting account must have sufficient rights to perform this operation:   roles/all, canRead
         * @summary getRoles - Get range of roles
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'roleName' | 'roleName desc'>} [$orderby] An OData conformant orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles($search, $top, $skip, $filter, $count, $orderby, options) {
            return localVarFp.getRoles($search, $top, $skip, $filter, $count, $orderby, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a range of roles from the all roles collection in a given organisation. The requesting account must have sufficient rights to perform this operation. The visible collection is limited to the items the requesting account is allowed to access:   roles/all, canRead   roles, canRead (in organisationId)
         * @summary getRolesInOrganisation - Get range of roles
         * @param {string} organisationId The ID of the organisation resource
         * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Array<'roleName' | 'roleName desc'>} [$orderby] An OData conformant orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, options) {
            return localVarFp.getRolesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, options).then((request) => request(axios, basePath));
        },
        /**
         * Partially updates the role {roleId}. The requesting account must have sufficient rights to perform this operation.
         * @summary updateRole - Partially update the role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {RoleUpdate} roleUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(roleId, roleUpdate, options) {
            return localVarFp.updateRole(roleId, roleUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Assigns access rights set to the existing role {roleId}. The access rights of role {roleID } on one rights object listed in the body are overwritten. To remove access rights on a rights object it must be listed in the body with the access rights set to false. The requesting account must have sufficient rights to perform this operation:   * roles, canUpdate (in {organisationId})   or   * roles/all, canUpdate
         * @summary updateRoleAccessRights - Assign access rights to role {roleId}
         * @param {string} roleId The ID of the role resource
         * @param {string} organisationId The ID of the organisation resource
         * @param {MultipleRightsObjectRightsAssociationUpdate} multipleRightsObjectRightsAssociationUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleAccessRights(roleId, organisationId, multipleRightsObjectRightsAssociationUpdate, options) {
            return localVarFp.updateRoleAccessRights(roleId, organisationId, multipleRightsObjectRightsAssociationUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
class RolesApi extends base_1.BaseAPI {
    /**
     * Creates a new role in a given organisation. The requesting account may have to be associated with the specified organisation depending on the access rights of the requesting account. An arbitrary organisation requires special access rights. The name of the role must be unique in the specified organisation. The requesting account must have sufficient rights to perform this operation.
     * @summary createRoleInOrganisation - Create role in organisation
     * @param {string} organisationId The ID of the organisation resource
     * @param {RoleCreate} roleCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    createRoleInOrganisation(organisationId, roleCreate, options) {
        return exports.RolesApiFp(this.configuration).createRoleInOrganisation(organisationId, roleCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes role {roleId}. The requesting account must have sufficient rights to perform this operation. Roles that are assigned to accounts cannot be deleted.
     * @summary deleteRole - Delete role {roleId}
     * @param {string} roleId The ID of the role resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    deleteRole(roleId, options) {
        return exports.RolesApiFp(this.configuration).deleteRole(roleId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the collection of access rights sets associated with role {roleId}. The requesting account must have sufficient rights to perform this operation:   * roles, canRead (in {organisationId})   or   * roles/all, canRead
     * @summary getRoleAccessRights - Get access rights associated with role {roleId}
     * @param {string} roleId The ID of the role resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    getRoleAccessRights(roleId, organisationId, options) {
        return exports.RolesApiFp(this.configuration).getRoleAccessRights(roleId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a range of roles from the all roles collection. The requesting account must have sufficient rights to perform this operation:   roles/all, canRead
     * @summary getRoles - Get range of roles
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Array<'roleName' | 'roleName desc'>} [$orderby] An OData conformant orderby string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    getRoles($search, $top, $skip, $filter, $count, $orderby, options) {
        return exports.RolesApiFp(this.configuration).getRoles($search, $top, $skip, $filter, $count, $orderby, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a range of roles from the all roles collection in a given organisation. The requesting account must have sufficient rights to perform this operation. The visible collection is limited to the items the requesting account is allowed to access:   roles/all, canRead   roles, canRead (in organisationId)
     * @summary getRolesInOrganisation - Get range of roles
     * @param {string} organisationId The ID of the organisation resource
     * @param {string} [$search] An OData conformant $search parameter. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Array<'roleName' | 'roleName desc'>} [$orderby] An OData conformant orderby string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    getRolesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, options) {
        return exports.RolesApiFp(this.configuration).getRolesInOrganisation(organisationId, $search, $top, $skip, $filter, $count, $orderby, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Partially updates the role {roleId}. The requesting account must have sufficient rights to perform this operation.
     * @summary updateRole - Partially update the role {roleId}
     * @param {string} roleId The ID of the role resource
     * @param {RoleUpdate} roleUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    updateRole(roleId, roleUpdate, options) {
        return exports.RolesApiFp(this.configuration).updateRole(roleId, roleUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Assigns access rights set to the existing role {roleId}. The access rights of role {roleID } on one rights object listed in the body are overwritten. To remove access rights on a rights object it must be listed in the body with the access rights set to false. The requesting account must have sufficient rights to perform this operation:   * roles, canUpdate (in {organisationId})   or   * roles/all, canUpdate
     * @summary updateRoleAccessRights - Assign access rights to role {roleId}
     * @param {string} roleId The ID of the role resource
     * @param {string} organisationId The ID of the organisation resource
     * @param {MultipleRightsObjectRightsAssociationUpdate} multipleRightsObjectRightsAssociationUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    updateRoleAccessRights(roleId, organisationId, multipleRightsObjectRightsAssociationUpdate, options) {
        return exports.RolesApiFp(this.configuration).updateRoleAccessRights(roleId, organisationId, multipleRightsObjectRightsAssociationUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RolesApi = RolesApi;
/**
 * ServiceApi - axios parameter creator
 * @export
 */
exports.ServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * test route
         * @summary getLandingPage - Get an informtional landing page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingPage: async (options = {}) => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the liveness of the service
         * @summary getServiceLiveness - Get service liveness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceLiveness: async (options = {}) => {
            const localVarPath = `/service/liveness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the readiness of the service
         * @summary getServiceReadiness - Get service readiness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceReadiness: async (options = {}) => {
            const localVarPath = `/service/readiness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets status information for the service
         * @summary getServiceStatus - Get service status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatus: async (options = {}) => {
            const localVarPath = `/service/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceApi - functional programming interface
 * @export
 */
exports.ServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ServiceApiAxiosParamCreator(configuration);
    return {
        /**
         * test route
         * @summary getLandingPage - Get an informtional landing page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandingPage(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLandingPage(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets the liveness of the service
         * @summary getServiceLiveness - Get service liveness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceLiveness(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceLiveness(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets the readiness of the service
         * @summary getServiceReadiness - Get service readiness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceReadiness(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceReadiness(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets status information for the service
         * @summary getServiceStatus - Get service status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceStatus(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * ServiceApi - factory interface
 * @export
 */
exports.ServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ServiceApiFp(configuration);
    return {
        /**
         * test route
         * @summary getLandingPage - Get an informtional landing page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingPage(options) {
            return localVarFp.getLandingPage(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the liveness of the service
         * @summary getServiceLiveness - Get service liveness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceLiveness(options) {
            return localVarFp.getServiceLiveness(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the readiness of the service
         * @summary getServiceReadiness - Get service readiness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceReadiness(options) {
            return localVarFp.getServiceReadiness(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets status information for the service
         * @summary getServiceStatus - Get service status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatus(options) {
            return localVarFp.getServiceStatus(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
class ServiceApi extends base_1.BaseAPI {
    /**
     * test route
     * @summary getLandingPage - Get an informtional landing page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getLandingPage(options) {
        return exports.ServiceApiFp(this.configuration).getLandingPage(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the liveness of the service
     * @summary getServiceLiveness - Get service liveness
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getServiceLiveness(options) {
        return exports.ServiceApiFp(this.configuration).getServiceLiveness(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the readiness of the service
     * @summary getServiceReadiness - Get service readiness
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getServiceReadiness(options) {
        return exports.ServiceApiFp(this.configuration).getServiceReadiness(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets status information for the service
     * @summary getServiceStatus - Get service status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getServiceStatus(options) {
        return exports.ServiceApiFp(this.configuration).getServiceStatus(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ServiceApi = ServiceApi;
//# sourceMappingURL=api.js.map